import { j as O, c as Js } from "./utils-BdNIfrGQ.js";
import { createContext as Tt, useRef as ot, useLayoutEffect as Wr, useEffect as ie, useContext as I, useId as Ur, useCallback as _e, useMemo as re, useInsertionEffect as $r, forwardRef as Kr, Fragment as Qs, createElement as zr, Component as Hr, Children as Rn } from "react";
import { D as Ut } from "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import "./Flex-BA9xHq_p.js";
import { n as Gr } from "./normalize-spacing-DY0KSpr_.js";
import { n as _r } from "./normalize-gap-CHOQjV8I.js";
import { G as Xr } from "./Grid-DJGISvmf.js";
import { c as Yr } from "./index-Di82Y7n3.js";
import "./theme/provider/ThemeProvider.mjs";
import "./NavLink-D9Qfouy1.js";
import "./HamburgerMenu-DtU03V0t.js";
import "./components/avatar/Avatar.mjs";
import { u as qr } from "./ResponsiveProvider-BC7BKjLV.js";
import "./Button-CzIiGCVn.js";
import "./toast-DrFMmSLk.js";
import "react-dom";
import "./Button.skeleton-D0Onk1OP.js";
const ti = Tt({});
function ei(t) {
  const e = ot(null);
  return e.current === null && (e.current = t()), e.current;
}
const Xe = typeof window < "u", ni = Xe ? Wr : ie, Ye = /* @__PURE__ */ Tt(null);
function qe(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Ze(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const Y = (t, e, n) => n > e ? e : n < t ? t : n;
let xt = () => {
}, H = () => {
};
if (process.env.NODE_ENV !== "production") {
  const t = (e, n) => n ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${n}` : e;
  xt = (e, n, s) => {
    !e && typeof console < "u" && console.warn(t(n, s));
  }, H = (e, n, s) => {
    if (!e)
      throw new Error(t(n, s));
  };
}
const J = {}, si = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
function ii(t) {
  return typeof t == "object" && t !== null;
}
const ri = (t) => /^0[^.\s]+$/u.test(t);
// @__NO_SIDE_EFFECTS__
function Je(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const N = /* @__NO_SIDE_EFFECTS__ */ (t) => t, Zr = (t, e) => (n) => e(t(n)), It = (...t) => t.reduce(Zr), yt = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const s = e - t;
  return s === 0 ? 1 : (n - t) / s;
};
class Qe {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return qe(this.subscriptions, e), () => Ze(this.subscriptions, e);
  }
  notify(e, n, s) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, s);
      else
        for (let o = 0; o < i; o++) {
          const r = this.subscriptions[o];
          r && r(e, n, s);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const z = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, _ = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function tn(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const Ln = /* @__PURE__ */ new Set();
function oe(t, e, n) {
  t || Ln.has(e) || (console.warn(e), Ln.add(e));
}
const oi = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, Jr = 1e-7, Qr = 12;
function to(t, e, n, s, i) {
  let o, r, a = 0;
  do
    r = e + (n - e) / 2, o = oi(r, s, i) - t, o > 0 ? n = r : e = r;
  while (Math.abs(o) > Jr && ++a < Qr);
  return r;
}
function jt(t, e, n, s) {
  if (t === e && n === s)
    return N;
  const i = (o) => to(o, 0, 1, t, n);
  return (o) => o === 0 || o === 1 ? o : oi(i(o), e, s);
}
const ai = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, li = (t) => (e) => 1 - t(1 - e), ci = /* @__PURE__ */ jt(0.33, 1.53, 0.69, 0.99), en = /* @__PURE__ */ li(ci), ui = /* @__PURE__ */ ai(en), hi = (t) => (t *= 2) < 1 ? 0.5 * en(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), nn = (t) => 1 - Math.sin(Math.acos(t)), fi = li(nn), di = ai(nn), eo = /* @__PURE__ */ jt(0.42, 0, 1, 1), no = /* @__PURE__ */ jt(0, 0, 0.58, 1), mi = /* @__PURE__ */ jt(0.42, 0, 0.58, 1), so = (t) => Array.isArray(t) && typeof t[0] != "number", pi = (t) => Array.isArray(t) && typeof t[0] == "number", kn = {
  linear: N,
  easeIn: eo,
  easeInOut: mi,
  easeOut: no,
  circIn: nn,
  circInOut: di,
  circOut: fi,
  backIn: en,
  backInOut: ui,
  backOut: ci,
  anticipate: hi
}, io = (t) => typeof t == "string", Bn = (t) => {
  if (pi(t)) {
    H(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, n, s, i] = t;
    return jt(e, n, s, i);
  } else if (io(t))
    return H(kn[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), kn[t];
  return t;
}, $t = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function ro(t, e) {
  let n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), i = !1, o = !1;
  const r = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(c) {
    r.has(c) && (u.schedule(c), t()), c(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, h = !1, f = !1) => {
      const m = f && i ? n : s;
      return h && r.add(c), m.has(c) || m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      s.delete(c), r.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, i) {
        o = !0;
        return;
      }
      i = !0, [n, s] = [s, n], n.forEach(l), n.clear(), i = !1, o && (o = !1, u.process(c));
    }
  };
  return u;
}
const oo = 40;
function gi(t, e) {
  let n = !1, s = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, r = $t.reduce((g, b) => (g[b] = ro(o), g), {}), { setup: a, read: l, resolveKeyframes: u, preUpdate: c, update: h, preRender: f, render: d, postRender: m } = r, v = () => {
    const g = J.useManualTiming ? i.timestamp : performance.now();
    n = !1, J.useManualTiming || (i.delta = s ? 1e3 / 60 : Math.max(Math.min(g - i.timestamp, oo), 1)), i.timestamp = g, i.isProcessing = !0, a.process(i), l.process(i), u.process(i), c.process(i), h.process(i), f.process(i), d.process(i), m.process(i), i.isProcessing = !1, n && e && (s = !1, t(v));
  }, y = () => {
    n = !0, s = !0, i.isProcessing || t(v);
  };
  return { schedule: $t.reduce((g, b) => {
    const P = r[b];
    return g[b] = (A, E = !1, w = !1) => (n || y(), P.schedule(A, E, w)), g;
  }, {}), cancel: (g) => {
    for (let b = 0; b < $t.length; b++)
      r[$t[b]].cancel(g);
  }, state: i, steps: r };
}
const { schedule: S, cancel: q, state: R, steps: fe } = /* @__PURE__ */ gi(typeof requestAnimationFrame < "u" ? requestAnimationFrame : N, !0);
let Gt;
function ao() {
  Gt = void 0;
}
const j = {
  now: () => (Gt === void 0 && j.set(R.isProcessing || J.useManualTiming ? R.timestamp : performance.now()), Gt),
  set: (t) => {
    Gt = t, queueMicrotask(ao);
  }
}, yi = (t) => (e) => typeof e == "string" && e.startsWith(t), sn = /* @__PURE__ */ yi("--"), lo = /* @__PURE__ */ yi("var(--"), rn = (t) => lo(t) ? co.test(t.split("/*")[0].trim()) : !1, co = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Pt = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, Rt = {
  ...Pt,
  transform: (t) => Y(0, 1, t)
}, Kt = {
  ...Pt,
  default: 1
}, Mt = (t) => Math.round(t * 1e5) / 1e5, on = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function uo(t) {
  return t == null;
}
const ho = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, an = (t, e) => (n) => !!(typeof n == "string" && ho.test(n) && n.startsWith(t) || e && !uo(n) && Object.prototype.hasOwnProperty.call(n, e)), vi = (t, e, n) => (s) => {
  if (typeof s != "string")
    return s;
  const [i, o, r, a] = s.match(on);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(o),
    [n]: parseFloat(r),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, fo = (t) => Y(0, 255, t), de = {
  ...Pt,
  transform: (t) => Math.round(fo(t))
}, it = {
  test: /* @__PURE__ */ an("rgb", "red"),
  parse: /* @__PURE__ */ vi("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: s = 1 }) => "rgba(" + de.transform(t) + ", " + de.transform(e) + ", " + de.transform(n) + ", " + Mt(Rt.transform(s)) + ")"
};
function mo(t) {
  let e = "", n = "", s = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, s += s, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(s, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const Ve = {
  test: /* @__PURE__ */ an("#"),
  parse: mo,
  transform: it.transform
}, Nt = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Q = /* @__PURE__ */ Nt("deg"), X = /* @__PURE__ */ Nt("%"), x = /* @__PURE__ */ Nt("px"), po = /* @__PURE__ */ Nt("vh"), go = /* @__PURE__ */ Nt("vw"), Fn = {
  ...X,
  parse: (t) => X.parse(t) / 100,
  transform: (t) => X.transform(t * 100)
}, ut = {
  test: /* @__PURE__ */ an("hsl", "hue"),
  parse: /* @__PURE__ */ vi("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 }) => "hsla(" + Math.round(t) + ", " + X.transform(Mt(e)) + ", " + X.transform(Mt(n)) + ", " + Mt(Rt.transform(s)) + ")"
}, C = {
  test: (t) => it.test(t) || Ve.test(t) || ut.test(t),
  parse: (t) => it.test(t) ? it.parse(t) : ut.test(t) ? ut.parse(t) : Ve.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? it.transform(t) : ut.transform(t),
  getAnimatableNone: (t) => {
    const e = C.parse(t);
    return e.alpha = 0, C.transform(e);
  }
}, yo = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function vo(t) {
  return isNaN(t) && typeof t == "string" && (t.match(on)?.length || 0) + (t.match(yo)?.length || 0) > 0;
}
const Ti = "number", xi = "color", To = "var", xo = "var(", On = "${}", Po = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Lt(t) {
  const e = t.toString(), n = [], s = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const a = e.replace(Po, (l) => (C.test(l) ? (s.color.push(o), i.push(xi), n.push(C.parse(l))) : l.startsWith(xo) ? (s.var.push(o), i.push(To), n.push(l)) : (s.number.push(o), i.push(Ti), n.push(parseFloat(l))), ++o, On)).split(On);
  return { values: n, split: a, indexes: s, types: i };
}
function Pi(t) {
  return Lt(t).values;
}
function wi(t) {
  const { split: e, types: n } = Lt(t), s = e.length;
  return (i) => {
    let o = "";
    for (let r = 0; r < s; r++)
      if (o += e[r], i[r] !== void 0) {
        const a = n[r];
        a === Ti ? o += Mt(i[r]) : a === xi ? o += C.transform(i[r]) : o += i[r];
      }
    return o;
  };
}
const wo = (t) => typeof t == "number" ? 0 : C.test(t) ? C.getAnimatableNone(t) : t;
function bo(t) {
  const e = Pi(t);
  return wi(t)(e.map(wo));
}
const tt = {
  test: vo,
  parse: Pi,
  createTransformer: wi,
  getAnimatableNone: bo
};
function me(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function So({ hue: t, saturation: e, lightness: n, alpha: s }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, o = 0, r = 0;
  if (!e)
    i = o = r = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    i = me(l, a, t + 1 / 3), o = me(l, a, t), r = me(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(r * 255),
    alpha: s
  };
}
function Qt(t, e) {
  return (n) => n > 0 ? e : t;
}
const M = (t, e, n) => t + (e - t) * n, pe = (t, e, n) => {
  const s = t * t, i = n * (e * e - s) + s;
  return i < 0 ? 0 : Math.sqrt(i);
}, Ao = [Ve, it, ut], Vo = (t) => Ao.find((e) => e.test(t));
function In(t) {
  const e = Vo(t);
  if (xt(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let n = e.parse(t);
  return e === ut && (n = So(n)), n;
}
const jn = (t, e) => {
  const n = In(t), s = In(e);
  if (!n || !s)
    return Qt(t, e);
  const i = { ...n };
  return (o) => (i.red = pe(n.red, s.red, o), i.green = pe(n.green, s.green, o), i.blue = pe(n.blue, s.blue, o), i.alpha = M(n.alpha, s.alpha, o), it.transform(i));
}, Me = /* @__PURE__ */ new Set(["none", "hidden"]);
function Mo(t, e) {
  return Me.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function Do(t, e) {
  return (n) => M(t, e, n);
}
function ln(t) {
  return typeof t == "number" ? Do : typeof t == "string" ? rn(t) ? Qt : C.test(t) ? jn : Ro : Array.isArray(t) ? bi : typeof t == "object" ? C.test(t) ? jn : Co : Qt;
}
function bi(t, e) {
  const n = [...t], s = n.length, i = t.map((o, r) => ln(o)(o, e[r]));
  return (o) => {
    for (let r = 0; r < s; r++)
      n[r] = i[r](o);
    return n;
  };
}
function Co(t, e) {
  const n = { ...t, ...e }, s = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (s[i] = ln(t[i])(t[i], e[i]));
  return (i) => {
    for (const o in s)
      n[o] = s[o](i);
    return n;
  };
}
function Eo(t, e) {
  const n = [], s = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const o = e.types[i], r = t.indexes[o][s[o]], a = t.values[r] ?? 0;
    n[i] = a, s[o]++;
  }
  return n;
}
const Ro = (t, e) => {
  const n = tt.createTransformer(e), s = Lt(t), i = Lt(e);
  return s.indexes.var.length === i.indexes.var.length && s.indexes.color.length === i.indexes.color.length && s.indexes.number.length >= i.indexes.number.length ? Me.has(t) && !i.values.length || Me.has(e) && !s.values.length ? Mo(t, e) : It(bi(Eo(s, i), i.values), n) : (xt(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Qt(t, e));
};
function Si(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? M(t, e, n) : ln(t)(t, e);
}
const Lo = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: (n = !0) => S.update(e, n),
    stop: () => q(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => R.isProcessing ? R.timestamp : j.now()
  };
}, Ai = (t, e, n = 10) => {
  let s = "";
  const i = Math.max(Math.round(e / n), 2);
  for (let o = 0; o < i; o++)
    s += Math.round(t(o / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${s.substring(0, s.length - 2)})`;
}, te = 2e4;
function cn(t) {
  let e = 0;
  const n = 50;
  let s = t.next(e);
  for (; !s.done && e < te; )
    e += n, s = t.next(e);
  return e >= te ? 1 / 0 : e;
}
function ko(t, e = 100, n) {
  const s = n({ ...t, keyframes: [0, e] }), i = Math.min(cn(s), te);
  return {
    type: "keyframes",
    ease: (o) => s.next(i * o).value / e,
    duration: /* @__PURE__ */ _(i)
  };
}
const Bo = 5;
function Vi(t, e, n) {
  const s = Math.max(e - Bo, 0);
  return tn(n - t(s), e - s);
}
const V = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, ge = 1e-3;
function Fo({ duration: t = V.duration, bounce: e = V.bounce, velocity: n = V.velocity, mass: s = V.mass }) {
  let i, o;
  xt(t <= /* @__PURE__ */ z(V.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let r = 1 - e;
  r = Y(V.minDamping, V.maxDamping, r), t = Y(V.minDuration, V.maxDuration, /* @__PURE__ */ _(t)), r < 1 ? (i = (u) => {
    const c = u * r, h = c * t, f = c - n, d = De(u, r), m = Math.exp(-h);
    return ge - f / d * m;
  }, o = (u) => {
    const h = u * r * t, f = h * n + n, d = Math.pow(r, 2) * Math.pow(u, 2) * t, m = Math.exp(-h), v = De(Math.pow(u, 2), r);
    return (-i(u) + ge > 0 ? -1 : 1) * ((f - d) * m) / v;
  }) : (i = (u) => {
    const c = Math.exp(-u * t), h = (u - n) * t + 1;
    return -ge + c * h;
  }, o = (u) => {
    const c = Math.exp(-u * t), h = (n - u) * (t * t);
    return c * h;
  });
  const a = 5 / t, l = Io(i, o, a);
  if (t = /* @__PURE__ */ z(t), isNaN(l))
    return {
      stiffness: V.stiffness,
      damping: V.damping,
      duration: t
    };
  {
    const u = Math.pow(l, 2) * s;
    return {
      stiffness: u,
      damping: r * 2 * Math.sqrt(s * u),
      duration: t
    };
  }
}
const Oo = 12;
function Io(t, e, n) {
  let s = n;
  for (let i = 1; i < Oo; i++)
    s = s - t(s) / e(s);
  return s;
}
function De(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const jo = ["duration", "bounce"], No = ["stiffness", "damping", "mass"];
function Nn(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Wo(t) {
  let e = {
    velocity: V.velocity,
    stiffness: V.stiffness,
    damping: V.damping,
    mass: V.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Nn(t, No) && Nn(t, jo))
    if (t.visualDuration) {
      const n = t.visualDuration, s = 2 * Math.PI / (n * 1.2), i = s * s, o = 2 * Y(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: V.mass,
        stiffness: i,
        damping: o
      };
    } else {
      const n = Fo(t);
      e = {
        ...e,
        ...n,
        mass: V.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function ee(t = V.visualDuration, e = V.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: s, restDelta: i } = n;
  const o = n.keyframes[0], r = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: o }, { stiffness: l, damping: u, mass: c, duration: h, velocity: f, isResolvedFromDuration: d } = Wo({
    ...n,
    velocity: -/* @__PURE__ */ _(n.velocity || 0)
  }), m = f || 0, v = u / (2 * Math.sqrt(l * c)), y = r - o, p = /* @__PURE__ */ _(Math.sqrt(l / c)), T = Math.abs(y) < 5;
  s || (s = T ? V.restSpeed.granular : V.restSpeed.default), i || (i = T ? V.restDelta.granular : V.restDelta.default);
  let g;
  if (v < 1) {
    const P = De(p, v);
    g = (A) => {
      const E = Math.exp(-v * p * A);
      return r - E * ((m + v * p * y) / P * Math.sin(P * A) + y * Math.cos(P * A));
    };
  } else if (v === 1)
    g = (P) => r - Math.exp(-p * P) * (y + (m + p * y) * P);
  else {
    const P = p * Math.sqrt(v * v - 1);
    g = (A) => {
      const E = Math.exp(-v * p * A), w = Math.min(P * A, 300);
      return r - E * ((m + v * p * y) * Math.sinh(w) + P * y * Math.cosh(w)) / P;
    };
  }
  const b = {
    calculatedDuration: d && h || null,
    next: (P) => {
      const A = g(P);
      if (d)
        a.done = P >= h;
      else {
        let E = P === 0 ? m : 0;
        v < 1 && (E = P === 0 ? /* @__PURE__ */ z(m) : Vi(g, P, A));
        const w = Math.abs(E) <= s, F = Math.abs(r - A) <= i;
        a.done = w && F;
      }
      return a.value = a.done ? r : A, a;
    },
    toString: () => {
      const P = Math.min(cn(b), te), A = Ai((E) => b.next(P * E).value, P, 30);
      return P + "ms " + A;
    },
    toTransition: () => {
    }
  };
  return b;
}
ee.applyToOptions = (t) => {
  const e = ko(t, 100, ee);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ z(e.duration), t.type = "keyframes", t;
};
function Ce({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: s = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: r, min: a, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const h = t[0], f = {
    done: !1,
    value: h
  }, d = (w) => a !== void 0 && w < a || l !== void 0 && w > l, m = (w) => a === void 0 ? l : l === void 0 || Math.abs(a - w) < Math.abs(l - w) ? a : l;
  let v = n * e;
  const y = h + v, p = r === void 0 ? y : r(y);
  p !== y && (v = p - h);
  const T = (w) => -v * Math.exp(-w / s), g = (w) => p + T(w), b = (w) => {
    const F = T(w), W = g(w);
    f.done = Math.abs(F) <= u, f.value = f.done ? p : W;
  };
  let P, A;
  const E = (w) => {
    d(f.value) && (P = w, A = ee({
      keyframes: [f.value, m(f.value)],
      velocity: Vi(g, w, f.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: u,
      restSpeed: c
    }));
  };
  return E(0), {
    calculatedDuration: null,
    next: (w) => {
      let F = !1;
      return !A && P === void 0 && (F = !0, b(w), E(w)), P !== void 0 && w >= P ? A.next(w - P) : (!F && b(w), f);
    }
  };
}
function Uo(t, e, n) {
  const s = [], i = n || J.mix || Si, o = t.length - 1;
  for (let r = 0; r < o; r++) {
    let a = i(t[r], t[r + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[r] || N : e;
      a = It(l, a);
    }
    s.push(a);
  }
  return s;
}
function Mi(t, e, { clamp: n = !0, ease: s, mixer: i } = {}) {
  const o = t.length;
  if (H(o === e.length, "Both input and output ranges must be the same length", "range-length"), o === 1)
    return () => e[0];
  if (o === 2 && e[0] === e[1])
    return () => e[1];
  const r = t[0] === t[1];
  t[0] > t[o - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const a = Uo(e, s, i), l = a.length, u = (c) => {
    if (r && c < t[0])
      return e[0];
    let h = 0;
    if (l > 1)
      for (; h < t.length - 2 && !(c < t[h + 1]); h++)
        ;
    const f = /* @__PURE__ */ yt(t[h], t[h + 1], c);
    return a[h](f);
  };
  return n ? (c) => u(Y(t[0], t[o - 1], c)) : u;
}
function $o(t, e) {
  const n = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const i = /* @__PURE__ */ yt(0, e, s);
    t.push(M(n, 1, i));
  }
}
function Di(t) {
  const e = [0];
  return $o(e, t.length - 1), e;
}
function Ko(t, e) {
  return t.map((n) => n * e);
}
function zo(t, e) {
  return t.map(() => e || mi).splice(0, t.length - 1);
}
function ht({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
  const i = so(s) ? s.map(Bn) : Bn(s), o = {
    done: !1,
    value: e[0]
  }, r = Ko(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Di(e),
    t
  ), a = Mi(r, e, {
    ease: Array.isArray(i) ? i : zo(e, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (o.value = a(l), o.done = l >= t, o)
  };
}
const Ho = (t) => t !== null;
function un(t, { repeat: e, repeatType: n = "loop" }, s, i = 1) {
  const o = t.filter(Ho), a = i < 0 || e && n !== "loop" && e % 2 === 1 ? 0 : o.length - 1;
  return !a || s === void 0 ? o[a] : s;
}
const Go = {
  decay: Ce,
  inertia: Ce,
  tween: ht,
  keyframes: ht,
  spring: ee
};
function Ci(t) {
  typeof t.type == "string" && (t.type = Go[t.type]);
}
class hn {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const _o = (t) => t / 100;
class fn extends hn {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      const { motionValue: n } = this.options;
      n && n.updatedAt !== j.now() && this.tick(j.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    Ci(e);
    const { type: n = ht, repeat: s = 0, repeatDelay: i = 0, repeatType: o, velocity: r = 0 } = e;
    let { keyframes: a } = e;
    const l = n || ht;
    process.env.NODE_ENV !== "production" && l !== ht && H(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== ht && typeof a[0] != "number" && (this.mixKeyframes = It(_o, Si(a[0], a[1])), a = [0, 100]);
    const u = l({ ...e, keyframes: a });
    o === "mirror" && (this.mirroredGenerator = l({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -r
    })), u.calculatedDuration === null && (u.calculatedDuration = cn(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (s + 1) - i, this.generator = u;
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(e, n = !1) {
    const { generator: s, totalDuration: i, mixKeyframes: o, mirroredGenerator: r, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return s.next(0);
    const { delay: u = 0, keyframes: c, repeat: h, repeatType: f, repeatDelay: d, type: m, onUpdate: v, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - i / this.speed, this.startTime)), n ? this.currentTime = e : this.updateTime(e);
    const p = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), T = this.playbackSpeed >= 0 ? p < 0 : p > i;
    this.currentTime = Math.max(p, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let g = this.currentTime, b = s;
    if (h) {
      const w = Math.min(this.currentTime, i) / a;
      let F = Math.floor(w), W = w % 1;
      !W && w >= 1 && (W = 1), W === 1 && F--, F = Math.min(F, h + 1), F % 2 && (f === "reverse" ? (W = 1 - W, d && (W -= d / a)) : f === "mirror" && (b = r)), g = Y(0, 1, W) * a;
    }
    const P = T ? { done: !1, value: c[0] } : b.next(g);
    o && (P.value = o(P.value));
    let { done: A } = P;
    !T && l !== null && (A = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const E = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return E && m !== Ce && (P.value = un(c, this.options, y, this.speed)), v && v(P.value), E && this.finish(), P;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return /* @__PURE__ */ _(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ _(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ z(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), this.driver?.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(j.now());
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ _(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: e = Lo, startTime: n } = this.options;
    this.driver || (this.driver = e((i) => this.tick(i))), this.options.onPlay?.();
    const s = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = s) : this.holdTime !== null ? this.startTime = s - this.holdTime : this.startTime || (this.startTime = n ?? s), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(j.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), e.observe(this);
  }
}
function Xo(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const rt = (t) => t * 180 / Math.PI, Ee = (t) => {
  const e = rt(Math.atan2(t[1], t[0]));
  return Re(e);
}, Yo = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
  rotate: Ee,
  rotateZ: Ee,
  skewX: (t) => rt(Math.atan(t[1])),
  skewY: (t) => rt(Math.atan(t[2])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2
}, Re = (t) => (t = t % 360, t < 0 && (t += 360), t), Wn = Ee, Un = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]), $n = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]), qo = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Un,
  scaleY: $n,
  scale: (t) => (Un(t) + $n(t)) / 2,
  rotateX: (t) => Re(rt(Math.atan2(t[6], t[5]))),
  rotateY: (t) => Re(rt(Math.atan2(-t[2], t[0]))),
  rotateZ: Wn,
  rotate: Wn,
  skewX: (t) => rt(Math.atan(t[4])),
  skewY: (t) => rt(Math.atan(t[1])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2
};
function Le(t) {
  return t.includes("scale") ? 1 : 0;
}
function ke(t, e) {
  if (!t || t === "none")
    return Le(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let s, i;
  if (n)
    s = qo, i = n;
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    s = Yo, i = a;
  }
  if (!i)
    return Le(e);
  const o = s[e], r = i[1].split(",").map(Jo);
  return typeof o == "function" ? o(r) : r[o];
}
const Zo = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return ke(n, e);
};
function Jo(t) {
  return parseFloat(t.trim());
}
const wt = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], bt = new Set(wt), Kn = (t) => t === Pt || t === x, Qo = /* @__PURE__ */ new Set(["x", "y", "z"]), ta = wt.filter((t) => !Qo.has(t));
function ea(t) {
  const e = [];
  return ta.forEach((n) => {
    const s = t.getValue(n);
    s !== void 0 && (e.push([n, s.get()]), s.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const at = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, { transform: e }) => ke(e, "x"),
  y: (t, { transform: e }) => ke(e, "y")
};
at.translateX = at.x;
at.translateY = at.y;
const lt = /* @__PURE__ */ new Set();
let Be = !1, Fe = !1, Oe = !1;
function Ei() {
  if (Fe) {
    const t = Array.from(lt).filter((s) => s.needsMeasurement), e = new Set(t.map((s) => s.element)), n = /* @__PURE__ */ new Map();
    e.forEach((s) => {
      const i = ea(s);
      i.length && (n.set(s, i), s.render());
    }), t.forEach((s) => s.measureInitialState()), e.forEach((s) => {
      s.render();
      const i = n.get(s);
      i && i.forEach(([o, r]) => {
        s.getValue(o)?.set(r);
      });
    }), t.forEach((s) => s.measureEndState()), t.forEach((s) => {
      s.suspendedScrollY !== void 0 && window.scrollTo(0, s.suspendedScrollY);
    });
  }
  Fe = !1, Be = !1, lt.forEach((t) => t.complete(Oe)), lt.clear();
}
function Ri() {
  lt.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Fe = !0);
  });
}
function na() {
  Oe = !0, Ri(), Ei(), Oe = !1;
}
class dn {
  constructor(e, n, s, i, o, r = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = s, this.motionValue = i, this.element = o, this.isAsync = r;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (lt.add(this), Be || (Be = !0, S.read(Ri), S.resolveKeyframes(Ei))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: s, motionValue: i } = this;
    if (e[0] === null) {
      const o = i?.get(), r = e[e.length - 1];
      if (o !== void 0)
        e[0] = o;
      else if (s && n) {
        const a = s.readValue(n, r);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = r), i && o === void 0 && i.set(e[0]);
    }
    Xo(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), lt.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (lt.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const sa = (t) => t.startsWith("--");
function ia(t, e, n) {
  sa(e) ? t.style.setProperty(e, n) : t.style[e] = n;
}
const Li = /* @__PURE__ */ Je(() => window.ScrollTimeline !== void 0), ra = {};
function oa(t, e) {
  const n = /* @__PURE__ */ Je(t);
  return () => ra[e] ?? n();
}
const ki = /* @__PURE__ */ oa(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Vt = ([t, e, n, s]) => `cubic-bezier(${t}, ${e}, ${n}, ${s})`, zn = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Vt([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Vt([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Vt([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Vt([0.33, 1.53, 0.69, 0.99])
};
function Bi(t, e) {
  if (t)
    return typeof t == "function" ? ki() ? Ai(t, e) : "ease-out" : pi(t) ? Vt(t) : Array.isArray(t) ? t.map((n) => Bi(n, e) || zn.easeOut) : zn[t];
}
function aa(t, e, n, { delay: s = 0, duration: i = 300, repeat: o = 0, repeatType: r = "loop", ease: a = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [e]: n
  };
  l && (c.offset = l);
  const h = Bi(a, i);
  Array.isArray(h) && (c.easing = h);
  const f = {
    delay: s,
    duration: i,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: o + 1,
    direction: r === "reverse" ? "alternate" : "normal"
  };
  return u && (f.pseudoElement = u), t.animate(c, f);
}
function Fi(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function la({ type: t, ...e }) {
  return Fi(t) && ki() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class ca extends hn {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !e)
      return;
    const { element: n, name: s, keyframes: i, pseudoElement: o, allowFlatten: r = !1, finalKeyframe: a, onComplete: l } = e;
    this.isPseudoElement = !!o, this.allowFlatten = r, this.options = e, H(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = la(e);
    this.animation = aa(n, s, i, u, o), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !o) {
        const c = un(i, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : ia(n, s, c), this.animation.cancel();
      }
      l?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    this.isPseudoElement || this.animation.commitStyles?.();
  }
  get duration() {
    const e = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ _(Number(e));
  }
  get time() {
    return /* @__PURE__ */ _(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ z(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, observe: n }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, e && Li() ? (this.animation.timeline = e, N) : n(this);
  }
}
const Oi = {
  anticipate: hi,
  backInOut: ui,
  circInOut: di
};
function ua(t) {
  return t in Oi;
}
function ha(t) {
  typeof t.ease == "string" && ua(t.ease) && (t.ease = Oi[t.ease]);
}
const Hn = 10;
class fa extends ca {
  constructor(e) {
    ha(e), Ci(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: n, onUpdate: s, onComplete: i, element: o, ...r } = this.options;
    if (!n)
      return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const a = new fn({
      ...r,
      autoplay: !1
    }), l = /* @__PURE__ */ z(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(l - Hn).value, a.sample(l).value, Hn), a.stop();
  }
}
const Gn = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(tt.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function da(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function ma(t, e, n, s) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const o = t[t.length - 1], r = Gn(i, e), a = Gn(o, e);
  return xt(r === a, `You are trying to animate ${e} from "${i}" to "${o}". "${r ? o : i}" is not an animatable value.`, "value-not-animatable"), !r || !a ? !1 : da(t) || (n === "spring" || Fi(n)) && s;
}
function mn(t) {
  return ii(t) && "offsetHeight" in t;
}
const pa = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), ga = /* @__PURE__ */ Je(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function ya(t) {
  const { motionValue: e, name: n, repeatDelay: s, repeatType: i, damping: o, type: r } = t;
  if (!mn(e?.owner?.current))
    return !1;
  const { onUpdate: a, transformTemplate: l } = e.owner.getProps();
  return ga() && n && pa.has(n) && (n !== "transform" || !l) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !a && !s && i !== "mirror" && o !== 0 && r !== "inertia";
}
const va = 40;
class Ta extends hn {
  constructor({ autoplay: e = !0, delay: n = 0, type: s = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: r = "loop", keyframes: a, name: l, motionValue: u, element: c, ...h }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = j.now();
    const f = {
      autoplay: e,
      delay: n,
      type: s,
      repeat: i,
      repeatDelay: o,
      repeatType: r,
      name: l,
      motionValue: u,
      element: c,
      ...h
    }, d = c?.KeyframeResolver || dn;
    this.keyframeResolver = new d(a, (m, v, y) => this.onKeyframesResolved(m, v, f, !y), l, u, c), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(e, n, s, i) {
    this.keyframeResolver = void 0;
    const { name: o, type: r, velocity: a, delay: l, isHandoff: u, onUpdate: c } = s;
    this.resolvedAt = j.now(), ma(e, o, r, a) || ((J.instantAnimations || !l) && c?.(un(e, s, n)), e[0] = e[e.length - 1], s.duration = 0, s.repeat = 0);
    const f = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > va ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...s,
      keyframes: e
    }, d = !u && ya(f) ? new fa({
      ...f,
      element: f.motionValue.owner.current
    }) : new fn(f);
    d.finished.then(() => this.notifyFinished()).catch(N), this.pendingTimeline && (this.stopTimeline = d.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = d;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), na()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
const xa = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Pa(t) {
  const e = xa.exec(t);
  if (!e)
    return [,];
  const [, n, s, i] = e;
  return [`--${n ?? s}`, i];
}
const wa = 4;
function Ii(t, e, n = 1) {
  H(n <= wa, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [s, i] = Pa(t);
  if (!s)
    return;
  const o = window.getComputedStyle(e).getPropertyValue(s);
  if (o) {
    const r = o.trim();
    return si(r) ? parseFloat(r) : r;
  }
  return rn(i) ? Ii(i, e, n + 1) : i;
}
function pn(t, e) {
  return t?.[e] ?? t?.default ?? t;
}
const ji = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...wt
]), ba = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Ni = (t) => (e) => e.test(t), Wi = [Pt, x, X, Q, go, po, ba], _n = (t) => Wi.find(Ni(t));
function Sa(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || ri(t) : !0;
}
const Aa = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Va(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [s] = n.match(on) || [];
  if (!s)
    return t;
  const i = n.replace(s, "");
  let o = Aa.has(e) ? 1 : 0;
  return s !== n && (o *= 100), e + "(" + o + i + ")";
}
const Ma = /\b([a-z-]*)\(.*?\)/gu, Ie = {
  ...tt,
  getAnimatableNone: (t) => {
    const e = t.match(Ma);
    return e ? e.map(Va).join(" ") : t;
  }
}, Xn = {
  ...Pt,
  transform: Math.round
}, Da = {
  rotate: Q,
  rotateX: Q,
  rotateY: Q,
  rotateZ: Q,
  scale: Kt,
  scaleX: Kt,
  scaleY: Kt,
  scaleZ: Kt,
  skew: Q,
  skewX: Q,
  skewY: Q,
  distance: x,
  translateX: x,
  translateY: x,
  translateZ: x,
  x,
  y: x,
  z: x,
  perspective: x,
  transformPerspective: x,
  opacity: Rt,
  originX: Fn,
  originY: Fn,
  originZ: x
}, gn = {
  // Border props
  borderWidth: x,
  borderTopWidth: x,
  borderRightWidth: x,
  borderBottomWidth: x,
  borderLeftWidth: x,
  borderRadius: x,
  radius: x,
  borderTopLeftRadius: x,
  borderTopRightRadius: x,
  borderBottomRightRadius: x,
  borderBottomLeftRadius: x,
  // Positioning props
  width: x,
  maxWidth: x,
  height: x,
  maxHeight: x,
  top: x,
  right: x,
  bottom: x,
  left: x,
  // Spacing props
  padding: x,
  paddingTop: x,
  paddingRight: x,
  paddingBottom: x,
  paddingLeft: x,
  margin: x,
  marginTop: x,
  marginRight: x,
  marginBottom: x,
  marginLeft: x,
  // Misc
  backgroundPositionX: x,
  backgroundPositionY: x,
  ...Da,
  zIndex: Xn,
  // SVG
  fillOpacity: Rt,
  strokeOpacity: Rt,
  numOctaves: Xn
}, Ca = {
  ...gn,
  // Color props
  color: C,
  backgroundColor: C,
  outlineColor: C,
  fill: C,
  stroke: C,
  // Border props
  borderColor: C,
  borderTopColor: C,
  borderRightColor: C,
  borderBottomColor: C,
  borderLeftColor: C,
  filter: Ie,
  WebkitFilter: Ie
}, Ui = (t) => Ca[t];
function $i(t, e) {
  let n = Ui(t);
  return n !== Ie && (n = tt), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const Ea = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function Ra(t, e, n) {
  let s = 0, i;
  for (; s < t.length && !i; ) {
    const o = t[s];
    typeof o == "string" && !Ea.has(o) && Lt(o).values.length && (i = t[s]), s++;
  }
  if (i && n)
    for (const o of e)
      t[o] = $i(n, i);
}
class La extends dn {
  constructor(e, n, s, i, o) {
    super(e, n, s, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: s } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let u = e[l];
      if (typeof u == "string" && (u = u.trim(), rn(u))) {
        const c = Ii(u, n.current);
        c !== void 0 && (e[l] = c), l === e.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !ji.has(s) || e.length !== 2)
      return;
    const [i, o] = e, r = _n(i), a = _n(o);
    if (r !== a)
      if (Kn(r) && Kn(a))
        for (let l = 0; l < e.length; l++) {
          const u = e[l];
          typeof u == "string" && (e[l] = parseFloat(u));
        }
      else at[s] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, s = [];
    for (let i = 0; i < e.length; i++)
      (e[i] === null || Sa(e[i])) && s.push(i);
    s.length && Ra(e, s, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: s } = this;
    if (!e || !e.current)
      return;
    s === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = at[s](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(s, i).jump(i, !1);
  }
  measureEndState() {
    const { element: e, name: n, unresolvedKeyframes: s } = this;
    if (!e || !e.current)
      return;
    const i = e.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const o = s.length - 1, r = s[o];
    s[o] = at[n](e.measureViewportBox(), window.getComputedStyle(e.current)), r !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = r), this.removedTransforms?.length && this.removedTransforms.forEach(([a, l]) => {
      e.getValue(a).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function Ki(t, e, n) {
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    const i = document.querySelectorAll(t);
    return i ? Array.from(i) : [];
  }
  return Array.from(t);
}
const zi = (t, e) => e && typeof t == "number" ? e.transform(t) : t, Yn = 30, ka = (t) => !isNaN(parseFloat(t));
class Ba {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (s, i = !0) => {
      const o = j.now();
      if (this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(s), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const r of this.dependents)
          r.dirty();
      i && this.events.renderRequest?.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = j.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = ka(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && oe(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Qe());
    const s = this.events[e].add(n);
    return e === "change" ? () => {
      s(), S.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, s) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = j.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Yn)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Yn);
    return tn(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function G(t, e) {
  return new Ba(t, e);
}
const { schedule: yn } = /* @__PURE__ */ gi(queueMicrotask, !1), K = {
  x: !1,
  y: !1
};
function Hi() {
  return K.x || K.y;
}
function Fa(t) {
  return t === "x" || t === "y" ? K[t] ? null : (K[t] = !0, () => {
    K[t] = !1;
  }) : K.x || K.y ? null : (K.x = K.y = !0, () => {
    K.x = K.y = !1;
  });
}
function Gi(t, e) {
  const n = Ki(t), s = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: s.signal
  };
  return [n, i, () => s.abort()];
}
function qn(t) {
  return !(t.pointerType === "touch" || Hi());
}
function Oa(t, e, n = {}) {
  const [s, i, o] = Gi(t, n), r = (a) => {
    if (!qn(a))
      return;
    const { target: l } = a, u = e(l, a);
    if (typeof u != "function" || !l)
      return;
    const c = (h) => {
      qn(h) && (u(h), l.removeEventListener("pointerleave", c));
    };
    l.addEventListener("pointerleave", c, i);
  };
  return s.forEach((a) => {
    a.addEventListener("pointerenter", r, i);
  }), o;
}
const _i = (t, e) => e ? t === e ? !0 : _i(t, e.parentElement) : !1, vn = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1, Ia = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function ja(t) {
  return Ia.has(t.tagName) || t.tabIndex !== -1;
}
const _t = /* @__PURE__ */ new WeakSet();
function Zn(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function ye(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const Na = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const s = Zn(() => {
    if (_t.has(n))
      return;
    ye(n, "down");
    const i = Zn(() => {
      ye(n, "up");
    }), o = () => ye(n, "cancel");
    n.addEventListener("keyup", i, e), n.addEventListener("blur", o, e);
  });
  n.addEventListener("keydown", s, e), n.addEventListener("blur", () => n.removeEventListener("keydown", s), e);
};
function Jn(t) {
  return vn(t) && !Hi();
}
function Wa(t, e, n = {}) {
  const [s, i, o] = Gi(t, n), r = (a) => {
    const l = a.currentTarget;
    if (!Jn(a))
      return;
    _t.add(l);
    const u = e(l, a), c = (d, m) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", f), _t.has(l) && _t.delete(l), Jn(d) && typeof u == "function" && u(d, { success: m });
    }, h = (d) => {
      c(d, l === window || l === document || n.useGlobalTarget || _i(l, d.target));
    }, f = (d) => {
      c(d, !1);
    };
    window.addEventListener("pointerup", h, i), window.addEventListener("pointercancel", f, i);
  };
  return s.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", r, i), mn(a) && (a.addEventListener("focus", (u) => Na(u, i)), !ja(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), o;
}
function Tn(t) {
  return ii(t) && "ownerSVGElement" in t;
}
const Xt = /* @__PURE__ */ new WeakMap();
let Yt;
const Xi = (t, e, n) => (s, i) => i && i[0] ? i[0][t + "Size"] : Tn(s) && "getBBox" in s ? s.getBBox()[e] : s[n], Ua = /* @__PURE__ */ Xi("inline", "width", "offsetWidth"), $a = /* @__PURE__ */ Xi("block", "height", "offsetHeight");
function Ka({ target: t, borderBoxSize: e }) {
  Xt.get(t)?.forEach((n) => {
    n(t, {
      get width() {
        return Ua(t, e);
      },
      get height() {
        return $a(t, e);
      }
    });
  });
}
function za(t) {
  t.forEach(Ka);
}
function Ha() {
  typeof ResizeObserver > "u" || (Yt = new ResizeObserver(za));
}
function Ga(t, e) {
  Yt || Ha();
  const n = Ki(t);
  return n.forEach((s) => {
    let i = Xt.get(s);
    i || (i = /* @__PURE__ */ new Set(), Xt.set(s, i)), i.add(e), Yt?.observe(s);
  }), () => {
    n.forEach((s) => {
      const i = Xt.get(s);
      i?.delete(e), i?.size || Yt?.unobserve(s);
    });
  };
}
const qt = /* @__PURE__ */ new Set();
let ft;
function _a() {
  ft = () => {
    const t = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    qt.forEach((e) => e(t));
  }, window.addEventListener("resize", ft);
}
function Xa(t) {
  return qt.add(t), ft || _a(), () => {
    qt.delete(t), !qt.size && typeof ft == "function" && (window.removeEventListener("resize", ft), ft = void 0);
  };
}
function Ya(t, e) {
  return typeof t == "function" ? Xa(t) : Ga(t, e);
}
function Yi(t, e) {
  let n;
  const s = () => {
    const { currentTime: i } = e, r = (i === null ? 0 : i.value) / 100;
    n !== r && t(r), n = r;
  };
  return S.preUpdate(s, !0), () => q(s);
}
function qa(t) {
  return Tn(t) && t.tagName === "svg";
}
const L = (t) => !!(t && t.getVelocity), Za = [...Wi, C, tt], Ja = (t) => Za.find(Ni(t)), qi = Tt({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
function Qa(t = !0) {
  const e = I(Ye);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: s, register: i } = e, o = Ur();
  ie(() => {
    if (t)
      return i(o);
  }, [t]);
  const r = _e(() => t && s && s(o), [o, s, t]);
  return !n && s ? [!1, r] : [!0];
}
const Zi = Tt({ strict: !1 }), Qn = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, vt = {};
for (const t in Qn)
  vt[t] = {
    isEnabled: (e) => Qn[t].some((n) => !!e[n])
  };
function tl(t) {
  for (const e in t)
    vt[e] = {
      ...vt[e],
      ...t[e]
    };
}
const el = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function ne(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || el.has(t);
}
let Ji = (t) => !ne(t);
function nl(t) {
  typeof t == "function" && (Ji = (e) => e.startsWith("on") ? !ne(e) : t(e));
}
try {
  nl(require("@emotion/is-prop-valid").default);
} catch {
}
function sl(t, e, n) {
  const s = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (Ji(i) || n === !0 && ne(i) || !e && !ne(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (s[i] = t[i]);
  return s;
}
function il(t) {
  if (typeof Proxy > "u")
    return t;
  const e = /* @__PURE__ */ new Map(), n = (...s) => (process.env.NODE_ENV !== "production" && oe(!1, "motion() is deprecated. Use motion.create() instead."), t(...s));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (s, i) => i === "create" ? t : (e.has(i) || e.set(i, t(i)), e.get(i))
  });
}
const ae = /* @__PURE__ */ Tt({});
function le(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function kt(t) {
  return typeof t == "string" || Array.isArray(t);
}
const xn = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Pn = ["initial", ...xn];
function ce(t) {
  return le(t.animate) || Pn.some((e) => kt(t[e]));
}
function Qi(t) {
  return !!(ce(t) || t.variants);
}
function rl(t, e) {
  if (ce(t)) {
    const { initial: n, animate: s } = t;
    return {
      initial: n === !1 || kt(n) ? n : void 0,
      animate: kt(s) ? s : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function ol(t) {
  const { initial: e, animate: n } = rl(t, I(ae));
  return re(() => ({ initial: e, animate: n }), [ts(e), ts(n)]);
}
function ts(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const al = /* @__PURE__ */ Symbol.for("motionComponentSymbol");
function dt(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function ll(t, e, n) {
  return _e(
    (s) => {
      s && t.onMount && t.onMount(s), e && (s ? e.mount(s) : e.unmount()), n && (typeof n == "function" ? n(s) : dt(n) && (n.current = s));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const wn = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), cl = "framerAppearId", tr = "data-" + wn(cl), er = Tt({});
function ul(t, e, n, s, i) {
  const { visualElement: o } = I(ae), r = I(Zi), a = I(Ye), l = I(qi).reducedMotion, u = ot(null);
  s = s || r.renderer, !u.current && s && (u.current = s(t, {
    visualState: e,
    parent: o,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const c = u.current, h = I(er);
  c && !c.projection && i && (c.type === "html" || c.type === "svg") && hl(u.current, n, i, h);
  const f = ot(!1);
  $r(() => {
    c && f.current && c.update(n, a);
  });
  const d = n[tr], m = ot(!!d && !window.MotionHandoffIsComplete?.(d) && window.MotionHasOptimisedAnimation?.(d));
  return ni(() => {
    c && (f.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), yn.render(c.render), m.current && c.animationState && c.animationState.animateChanges());
  }), ie(() => {
    c && (!m.current && c.animationState && c.animationState.animateChanges(), m.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(d);
    }), m.current = !1));
  }), c;
}
function hl(t, e, n, s) {
  const { layoutId: i, layout: o, drag: r, dragConstraints: a, layoutScroll: l, layoutRoot: u, layoutCrossfade: c } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : nr(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!r || a && dt(a),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: s,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: u
  });
}
function nr(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : nr(t.parent);
}
function fl({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: s, Component: i }) {
  t && tl(t);
  function o(a, l) {
    let u;
    const c = {
      ...I(qi),
      ...a,
      layoutId: dl(a)
    }, { isStatic: h } = c, f = ol(a), d = s(a, h);
    if (!h && Xe) {
      ml(c, t);
      const m = pl(c);
      u = m.MeasureLayout, f.visualElement = ul(i, d, c, e, m.ProjectionNode);
    }
    return O.jsxs(ae.Provider, { value: f, children: [u && f.visualElement ? O.jsx(u, { visualElement: f.visualElement, ...c }) : null, n(i, a, ll(d, f.visualElement, l), d, h, f.visualElement)] });
  }
  o.displayName = `motion.${typeof i == "string" ? i : `create(${i.displayName ?? i.name ?? ""})`}`;
  const r = Kr(o);
  return r[al] = i, r;
}
function dl({ layoutId: t }) {
  const e = I(ti).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function ml(t, e) {
  const n = I(Zi).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const s = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? xt(!1, s, "lazy-strict-mode") : H(!1, s, "lazy-strict-mode");
  }
}
function pl(t) {
  const { drag: e, layout: n } = vt;
  if (!e && !n)
    return {};
  const s = { ...e, ...n };
  return {
    MeasureLayout: e?.isEnabled(t) || n?.isEnabled(t) ? s.MeasureLayout : void 0,
    ProjectionNode: s.ProjectionNode
  };
}
const Bt = {};
function gl(t) {
  for (const e in t)
    Bt[e] = t[e], sn(e) && (Bt[e].isCSSVariable = !0);
}
function sr(t, { layout: e, layoutId: n }) {
  return bt.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!Bt[t] || t === "opacity");
}
const yl = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, vl = wt.length;
function Tl(t, e, n) {
  let s = "", i = !0;
  for (let o = 0; o < vl; o++) {
    const r = wt[o], a = t[r];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (r.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const u = zi(a, gn[r]);
      if (!l) {
        i = !1;
        const c = yl[r] || r;
        s += `${c}(${u}) `;
      }
      n && (e[r] = u);
    }
  }
  return s = s.trim(), n ? s = n(e, i ? "" : s) : i && (s = "none"), s;
}
function bn(t, e, n) {
  const { style: s, vars: i, transformOrigin: o } = t;
  let r = !1, a = !1;
  for (const l in e) {
    const u = e[l];
    if (bt.has(l)) {
      r = !0;
      continue;
    } else if (sn(l)) {
      i[l] = u;
      continue;
    } else {
      const c = zi(u, gn[l]);
      l.startsWith("origin") ? (a = !0, o[l] = c) : s[l] = c;
    }
  }
  if (e.transform || (r || n ? s.transform = Tl(e, t.transform, n) : s.transform && (s.transform = "none")), a) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = o;
    s.transformOrigin = `${l} ${u} ${c}`;
  }
}
const Sn = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function ir(t, e, n) {
  for (const s in e)
    !L(e[s]) && !sr(s, n) && (t[s] = e[s]);
}
function xl({ transformTemplate: t }, e) {
  return re(() => {
    const n = Sn();
    return bn(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function Pl(t, e) {
  const n = t.style || {}, s = {};
  return ir(s, n, t), Object.assign(s, xl(t, e)), s;
}
function wl(t, e) {
  const n = {}, s = Pl(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, s.userSelect = s.WebkitUserSelect = s.WebkitTouchCallout = "none", s.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = s, n;
}
const bl = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Sl = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Al(t, e, n = 1, s = 0, i = !0) {
  t.pathLength = 1;
  const o = i ? bl : Sl;
  t[o.offset] = x.transform(-s);
  const r = x.transform(e), a = x.transform(n);
  t[o.array] = `${r} ${a}`;
}
function rr(t, {
  attrX: e,
  attrY: n,
  attrScale: s,
  pathLength: i,
  pathSpacing: o = 1,
  pathOffset: r = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, u, c) {
  if (bn(t, a, u), l) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: h, style: f } = t;
  h.transform && (f.transform = h.transform, delete h.transform), (f.transform || h.transformOrigin) && (f.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), f.transform && (f.transformBox = c?.transformBox ?? "fill-box", delete h.transformBox), e !== void 0 && (h.x = e), n !== void 0 && (h.y = n), s !== void 0 && (h.scale = s), i !== void 0 && Al(h, i, o, r, !1);
}
const or = () => ({
  ...Sn(),
  attrs: {}
}), ar = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function Vl(t, e, n, s) {
  const i = re(() => {
    const o = or();
    return rr(o, e, ar(s), t.transformTemplate, t.style), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [e]);
  if (t.style) {
    const o = {};
    ir(o, t.style, t), i.style = { ...o, ...i.style };
  }
  return i;
}
const Ml = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function An(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Ml.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function Dl(t = !1) {
  return (n, s, i, { latestValues: o }, r) => {
    const l = (An(n) ? Vl : wl)(s, o, r, n), u = sl(s, typeof n == "string", t), c = n !== Qs ? { ...u, ...l, ref: i } : {}, { children: h } = s, f = re(() => L(h) ? h.get() : h, [h]);
    return zr(n, {
      ...c,
      children: f
    });
  };
}
function es(t) {
  const e = [{}, {}];
  return t?.values.forEach((n, s) => {
    e[0][s] = n.get(), e[1][s] = n.getVelocity();
  }), e;
}
function Vn(t, e, n, s) {
  if (typeof e == "function") {
    const [i, o] = es(s);
    e = e(n !== void 0 ? n : t.custom, i, o);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, o] = es(s);
    e = e(n !== void 0 ? n : t.custom, i, o);
  }
  return e;
}
function Zt(t) {
  return L(t) ? t.get() : t;
}
function Cl({ scrapeMotionValuesFromProps: t, createRenderState: e }, n, s, i) {
  return {
    latestValues: El(n, s, i, t),
    renderState: e()
  };
}
const lr = (t) => (e, n) => {
  const s = I(ae), i = I(Ye), o = () => Cl(t, e, s, i);
  return n ? o() : ei(o);
};
function El(t, e, n, s) {
  const i = {}, o = s(t, {});
  for (const f in o)
    i[f] = Zt(o[f]);
  let { initial: r, animate: a } = t;
  const l = ce(t), u = Qi(t);
  e && u && !l && t.inherit !== !1 && (r === void 0 && (r = e.initial), a === void 0 && (a = e.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || r === !1;
  const h = c ? a : r;
  if (h && typeof h != "boolean" && !le(h)) {
    const f = Array.isArray(h) ? h : [h];
    for (let d = 0; d < f.length; d++) {
      const m = Vn(t, f[d]);
      if (m) {
        const { transitionEnd: v, transition: y, ...p } = m;
        for (const T in p) {
          let g = p[T];
          if (Array.isArray(g)) {
            const b = c ? g.length - 1 : 0;
            g = g[b];
          }
          g !== null && (i[T] = g);
        }
        for (const T in v)
          i[T] = v[T];
      }
    }
  }
  return i;
}
function Mn(t, e, n) {
  const { style: s } = t, i = {};
  for (const o in s)
    (L(s[o]) || e.style && L(e.style[o]) || sr(o, t) || n?.getValue(o)?.liveStyle !== void 0) && (i[o] = s[o]);
  return i;
}
const Rl = {
  useVisualState: lr({
    scrapeMotionValuesFromProps: Mn,
    createRenderState: Sn
  })
};
function cr(t, e, n) {
  const s = Mn(t, e, n);
  for (const i in t)
    if (L(t[i]) || L(e[i])) {
      const o = wt.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      s[o] = t[i];
    }
  return s;
}
const Ll = {
  useVisualState: lr({
    scrapeMotionValuesFromProps: cr,
    createRenderState: or
  })
};
function kl(t, e) {
  return function(s, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const r = {
      ...An(s) ? Ll : Rl,
      preloadedFeatures: t,
      useRender: Dl(i),
      createVisualElement: e,
      Component: s
    };
    return fl(r);
  };
}
function Ft(t, e, n) {
  const s = t.getProps();
  return Vn(s, e, n !== void 0 ? n : s.custom, t);
}
const je = (t) => Array.isArray(t);
function Bl(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, G(n));
}
function Fl(t) {
  return je(t) ? t[t.length - 1] || 0 : t;
}
function Ol(t, e) {
  const n = Ft(t, e);
  let { transitionEnd: s = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...s };
  for (const r in o) {
    const a = Fl(o[r]);
    Bl(t, r, a);
  }
}
function Il(t) {
  return !!(L(t) && t.add);
}
function Ne(t, e) {
  const n = t.getValue("willChange");
  if (Il(n))
    return n.add(e);
  if (!n && J.WillChange) {
    const s = new J.WillChange("auto");
    t.addValue("willChange", s), s.add(e);
  }
}
function ur(t) {
  return t.props[tr];
}
const jl = (t) => t !== null;
function Nl(t, { repeat: e, repeatType: n = "loop" }, s) {
  const i = t.filter(jl), o = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return i[o];
}
const Wl = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Ul = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), $l = {
  type: "keyframes",
  duration: 0.8
}, Kl = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, zl = (t, { keyframes: e }) => e.length > 2 ? $l : bt.has(t) ? t.startsWith("scale") ? Ul(e[1]) : Wl : Kl;
function Hl({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: i, repeat: o, repeatType: r, repeatDelay: a, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const Dn = (t, e, n, s = {}, i, o) => (r) => {
  const a = pn(s, t) || {}, l = a.delay || s.delay || 0;
  let { elapsed: u = 0 } = s;
  u = u - /* @__PURE__ */ z(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (f) => {
      e.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      r(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: o ? void 0 : i
  };
  Hl(a) || Object.assign(c, zl(t, c)), c.duration && (c.duration = /* @__PURE__ */ z(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ z(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let h = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (c.duration = 0, c.delay === 0 && (h = !0)), (J.instantAnimations || J.skipAnimations) && (h = !0, c.duration = 0, c.delay = 0), c.allowFlatten = !a.type && !a.ease, h && !o && e.get() !== void 0) {
    const f = Nl(c.keyframes, a);
    if (f !== void 0) {
      S.update(() => {
        c.onUpdate(f), c.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new fn(c) : new Ta(c);
};
function Gl({ protectedKeys: t, needsAnimating: e }, n) {
  const s = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, s;
}
function hr(t, e, { delay: n = 0, transitionOverride: s, type: i } = {}) {
  let { transition: o = t.getDefaultTransition(), transitionEnd: r, ...a } = e;
  s && (o = s);
  const l = [], u = i && t.animationState && t.animationState.getState()[i];
  for (const c in a) {
    const h = t.getValue(c, t.latestValues[c] ?? null), f = a[c];
    if (f === void 0 || u && Gl(u, c))
      continue;
    const d = {
      delay: n,
      ...pn(o || {}, c)
    }, m = h.get();
    if (m !== void 0 && !h.isAnimating && !Array.isArray(f) && f === m && !d.velocity)
      continue;
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const p = ur(t);
      if (p) {
        const T = window.MotionHandoffAnimation(p, c, S);
        T !== null && (d.startTime = T, v = !0);
      }
    }
    Ne(t, c), h.start(Dn(c, h, f, t.shouldReduceMotion && ji.has(c) ? { type: !1 } : d, t, v));
    const y = h.animation;
    y && l.push(y);
  }
  return r && Promise.all(l).then(() => {
    S.update(() => {
      r && Ol(t, r);
    });
  }), l;
}
function We(t, e, n = {}) {
  const s = Ft(t, e, n.type === "exit" ? t.presenceContext?.custom : void 0);
  let { transition: i = t.getDefaultTransition() || {} } = s || {};
  n.transitionOverride && (i = n.transitionOverride);
  const o = s ? () => Promise.all(hr(t, s, n)) : () => Promise.resolve(), r = t.variantChildren && t.variantChildren.size ? (l = 0) => {
    const { delayChildren: u = 0, staggerChildren: c, staggerDirection: h } = i;
    return _l(t, e, l, u, c, h, n);
  } : () => Promise.resolve(), { when: a } = i;
  if (a) {
    const [l, u] = a === "beforeChildren" ? [o, r] : [r, o];
    return l().then(() => u());
  } else
    return Promise.all([o(), r(n.delay)]);
}
function _l(t, e, n = 0, s = 0, i = 0, o = 1, r) {
  const a = [], l = t.variantChildren.size, u = (l - 1) * i, c = typeof s == "function", h = c ? (f) => s(f, l) : (
    // Support deprecated staggerChildren
    o === 1 ? (f = 0) => f * i : (f = 0) => u - f * i
  );
  return Array.from(t.variantChildren).sort(Xl).forEach((f, d) => {
    f.notify("AnimationStart", e), a.push(We(f, e, {
      ...r,
      delay: n + (c ? 0 : s) + h(d)
    }).then(() => f.notify("AnimationComplete", e)));
  }), Promise.all(a);
}
function Xl(t, e) {
  return t.sortNodePosition(e);
}
function Yl(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let s;
  if (Array.isArray(e)) {
    const i = e.map((o) => We(t, o, n));
    s = Promise.all(i);
  } else if (typeof e == "string")
    s = We(t, e, n);
  else {
    const i = typeof e == "function" ? Ft(t, e, n.custom) : e;
    s = Promise.all(hr(t, i, n));
  }
  return s.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function fr(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let s = 0; s < n; s++)
    if (e[s] !== t[s])
      return !1;
  return !0;
}
const ql = Pn.length;
function dr(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? dr(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < ql; n++) {
    const s = Pn[n], i = t.props[s];
    (kt(i) || i === !1) && (e[s] = i);
  }
  return e;
}
const Zl = [...xn].reverse(), Jl = xn.length;
function Ql(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: s }) => Yl(t, n, s)));
}
function tc(t) {
  let e = Ql(t), n = ns(), s = !0;
  const i = (l) => (u, c) => {
    const h = Ft(t, c, l === "exit" ? t.presenceContext?.custom : void 0);
    if (h) {
      const { transition: f, transitionEnd: d, ...m } = h;
      u = { ...u, ...m, ...d };
    }
    return u;
  };
  function o(l) {
    e = l(t);
  }
  function r(l) {
    const { props: u } = t, c = dr(t.parent) || {}, h = [], f = /* @__PURE__ */ new Set();
    let d = {}, m = 1 / 0;
    for (let y = 0; y < Jl; y++) {
      const p = Zl[y], T = n[p], g = u[p] !== void 0 ? u[p] : c[p], b = kt(g), P = p === l ? T.isActive : null;
      P === !1 && (m = y);
      let A = g === c[p] && g !== u[p] && b;
      if (A && s && t.manuallyAnimateOnMount && (A = !1), T.protectedKeys = { ...d }, // If it isn't active and hasn't *just* been set as inactive
      !T.isActive && P === null || // If we didn't and don't have any defined prop for this animation type
      !g && !T.prevProp || // Or if the prop doesn't define an animation
      le(g) || typeof g == "boolean")
        continue;
      const E = ec(T.prevProp, g);
      let w = E || // If we're making this variant active, we want to always make it active
      p === l && T.isActive && !A && b || // If we removed a higher-priority variant (i is in reverse order)
      y > m && b, F = !1;
      const W = Array.isArray(g) ? g : [g];
      let ct = W.reduce(i(p), {});
      P === !1 && (ct = {});
      const { prevResolvedValues: Cn = {} } = T, Nr = {
        ...Cn,
        ...ct
      }, En = (k) => {
        w = !0, f.has(k) && (F = !0, f.delete(k)), T.needsAnimating[k] = !0;
        const Z = t.getValue(k);
        Z && (Z.liveStyle = !1);
      };
      for (const k in Nr) {
        const Z = ct[k], ue = Cn[k];
        if (d.hasOwnProperty(k))
          continue;
        let he = !1;
        je(Z) && je(ue) ? he = !fr(Z, ue) : he = Z !== ue, he ? Z != null ? En(k) : f.add(k) : Z !== void 0 && f.has(k) ? En(k) : T.protectedKeys[k] = !0;
      }
      T.prevProp = g, T.prevResolvedValues = ct, T.isActive && (d = { ...d, ...ct }), s && t.blockInitialAnimation && (w = !1), w && (!(A && E) || F) && h.push(...W.map((k) => ({
        animation: k,
        options: { type: p }
      })));
    }
    if (f.size) {
      const y = {};
      if (typeof u.initial != "boolean") {
        const p = Ft(t, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        p && p.transition && (y.transition = p.transition);
      }
      f.forEach((p) => {
        const T = t.getBaseTarget(p), g = t.getValue(p);
        g && (g.liveStyle = !0), y[p] = T ?? null;
      }), h.push({ animation: y });
    }
    let v = !!h.length;
    return s && (u.initial === !1 || u.initial === u.animate) && !t.manuallyAnimateOnMount && (v = !1), s = !1, v ? e(h) : Promise.resolve();
  }
  function a(l, u) {
    if (n[l].isActive === u)
      return Promise.resolve();
    t.variantChildren?.forEach((h) => h.animationState?.setActive(l, u)), n[l].isActive = u;
    const c = r(l);
    for (const h in n)
      n[h].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: r,
    setActive: a,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = ns(), s = !0;
    }
  };
}
function ec(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !fr(e, t) : !1;
}
function nt(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function ns() {
  return {
    animate: nt(!0),
    whileInView: nt(),
    whileHover: nt(),
    whileTap: nt(),
    whileDrag: nt(),
    whileFocus: nt(),
    exit: nt()
  };
}
class et {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class nc extends et {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = tc(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    le(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let sc = 0;
class ic extends et {
  constructor() {
    super(...arguments), this.id = sc++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: s } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === s)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    n && !e && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const rc = {
  animation: {
    Feature: nc
  },
  exit: {
    Feature: ic
  }
};
function Ot(t, e, n, s = { passive: !0 }) {
  return t.addEventListener(e, n, s), () => t.removeEventListener(e, n);
}
function Wt(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const oc = (t) => (e) => vn(e) && t(e, Wt(e));
function Dt(t, e, n, s) {
  return Ot(t, e, oc(n), s);
}
function mr({ top: t, left: e, right: n, bottom: s }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: s }
  };
}
function ac({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function lc(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), s = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: s.y,
    right: s.x
  };
}
const pr = 1e-4, cc = 1 - pr, uc = 1 + pr, gr = 0.01, hc = 0 - gr, fc = 0 + gr;
function B(t) {
  return t.max - t.min;
}
function dc(t, e, n) {
  return Math.abs(t - e) <= n;
}
function ss(t, e, n, s = 0.5) {
  t.origin = s, t.originPoint = M(e.min, e.max, t.origin), t.scale = B(n) / B(e), t.translate = M(n.min, n.max, t.origin) - t.originPoint, (t.scale >= cc && t.scale <= uc || isNaN(t.scale)) && (t.scale = 1), (t.translate >= hc && t.translate <= fc || isNaN(t.translate)) && (t.translate = 0);
}
function Ct(t, e, n, s) {
  ss(t.x, e.x, n.x, s ? s.originX : void 0), ss(t.y, e.y, n.y, s ? s.originY : void 0);
}
function is(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + B(e);
}
function mc(t, e, n) {
  is(t.x, e.x, n.x), is(t.y, e.y, n.y);
}
function rs(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + B(e);
}
function Et(t, e, n) {
  rs(t.x, e.x, n.x), rs(t.y, e.y, n.y);
}
const os = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), mt = () => ({
  x: os(),
  y: os()
}), as = () => ({ min: 0, max: 0 }), D = () => ({
  x: as(),
  y: as()
});
function $(t) {
  return [t("x"), t("y")];
}
function ve(t) {
  return t === void 0 || t === 1;
}
function Ue({ scale: t, scaleX: e, scaleY: n }) {
  return !ve(t) || !ve(e) || !ve(n);
}
function st(t) {
  return Ue(t) || yr(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function yr(t) {
  return ls(t.x) || ls(t.y);
}
function ls(t) {
  return t && t !== "0%";
}
function se(t, e, n) {
  const s = t - n, i = e * s;
  return n + i;
}
function cs(t, e, n, s, i) {
  return i !== void 0 && (t = se(t, i, s)), se(t, n, s) + e;
}
function $e(t, e = 0, n = 1, s, i) {
  t.min = cs(t.min, e, n, s, i), t.max = cs(t.max, e, n, s, i);
}
function vr(t, { x: e, y: n }) {
  $e(t.x, e.translate, e.scale, e.originPoint), $e(t.y, n.translate, n.scale, n.originPoint);
}
const us = 0.999999999999, hs = 1.0000000000001;
function pc(t, e, n, s = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let o, r;
  for (let a = 0; a < i; a++) {
    o = n[a], r = o.projectionDelta;
    const { visualElement: l } = o.options;
    l && l.props.style && l.props.style.display === "contents" || (s && o.options.layoutScroll && o.scroll && o !== o.root && gt(t, {
      x: -o.scroll.offset.x,
      y: -o.scroll.offset.y
    }), r && (e.x *= r.x.scale, e.y *= r.y.scale, vr(t, r)), s && st(o.latestValues) && gt(t, o.latestValues));
  }
  e.x < hs && e.x > us && (e.x = 1), e.y < hs && e.y > us && (e.y = 1);
}
function pt(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function fs(t, e, n, s, i = 0.5) {
  const o = M(t.min, t.max, i);
  $e(t, e, n, o, s);
}
function gt(t, e) {
  fs(t.x, e.x, e.scaleX, e.scale, e.originX), fs(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function Tr(t, e) {
  return mr(lc(t.getBoundingClientRect(), e));
}
function gc(t, e, n) {
  const s = Tr(t, n), { scroll: i } = e;
  return i && (pt(s.x, i.offset.x), pt(s.y, i.offset.y)), s;
}
const xr = ({ current: t }) => t ? t.ownerDocument.defaultView : null, ds = (t, e) => Math.abs(t - e);
function yc(t, e) {
  const n = ds(t.x, e.x), s = ds(t.y, e.y);
  return Math.sqrt(n ** 2 + s ** 2);
}
class Pr {
  constructor(e, n, { transformPagePoint: s, contextWindow: i = window, dragSnapToOrigin: o = !1, distanceThreshold: r = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = xe(this.lastMoveEventInfo, this.history), d = this.startEvent !== null, m = yc(f.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!d && !m)
        return;
      const { point: v } = f, { timestamp: y } = R;
      this.history.push({ ...v, timestamp: y });
      const { onStart: p, onMove: T } = this.handlers;
      d || (p && p(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), T && T(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, d) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = Te(d, this.transformPagePoint), S.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, d) => {
      this.end();
      const { onEnd: m, onSessionEnd: v, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const p = xe(f.type === "pointercancel" ? this.lastMoveEventInfo : Te(d, this.transformPagePoint), this.history);
      this.startEvent && m && m(f, p), v && v(f, p);
    }, !vn(e))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = s, this.distanceThreshold = r, this.contextWindow = i || window;
    const a = Wt(e), l = Te(a, this.transformPagePoint), { point: u } = l, { timestamp: c } = R;
    this.history = [{ ...u, timestamp: c }];
    const { onSessionStart: h } = n;
    h && h(e, xe(l, this.history)), this.removeListeners = It(Dt(this.contextWindow, "pointermove", this.handlePointerMove), Dt(this.contextWindow, "pointerup", this.handlePointerUp), Dt(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), q(this.updatePoint);
  }
}
function Te(t, e) {
  return e ? { point: e(t.point) } : t;
}
function ms(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function xe({ point: t }, e) {
  return {
    point: t,
    delta: ms(t, wr(e)),
    offset: ms(t, vc(e)),
    velocity: Tc(e, 0.1)
  };
}
function vc(t) {
  return t[0];
}
function wr(t) {
  return t[t.length - 1];
}
function Tc(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, s = null;
  const i = wr(t);
  for (; n >= 0 && (s = t[n], !(i.timestamp - s.timestamp > /* @__PURE__ */ z(e))); )
    n--;
  if (!s)
    return { x: 0, y: 0 };
  const o = /* @__PURE__ */ _(i.timestamp - s.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const r = {
    x: (i.x - s.x) / o,
    y: (i.y - s.y) / o
  };
  return r.x === 1 / 0 && (r.x = 0), r.y === 1 / 0 && (r.y = 0), r;
}
function xc(t, { min: e, max: n }, s) {
  return e !== void 0 && t < e ? t = s ? M(e, t, s.min) : Math.max(t, e) : n !== void 0 && t > n && (t = s ? M(n, t, s.max) : Math.min(t, n)), t;
}
function ps(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Pc(t, { top: e, left: n, bottom: s, right: i }) {
  return {
    x: ps(t.x, n, i),
    y: ps(t.y, e, s)
  };
}
function gs(t, e) {
  let n = e.min - t.min, s = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, s] = [s, n]), { min: n, max: s };
}
function wc(t, e) {
  return {
    x: gs(t.x, e.x),
    y: gs(t.y, e.y)
  };
}
function bc(t, e) {
  let n = 0.5;
  const s = B(t), i = B(e);
  return i > s ? n = /* @__PURE__ */ yt(e.min, e.max - s, t.min) : s > i && (n = /* @__PURE__ */ yt(t.min, t.max - i, e.min)), Y(0, 1, n);
}
function Sc(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const Ke = 0.35;
function Ac(t = Ke) {
  return t === !1 ? t = 0 : t === !0 && (t = Ke), {
    x: ys(t, "left", "right"),
    y: ys(t, "top", "bottom")
  };
}
function ys(t, e, n) {
  return {
    min: vs(t, e),
    max: vs(t, n)
  };
}
function vs(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const Vc = /* @__PURE__ */ new WeakMap();
class Mc {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = D(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1, distanceThreshold: s } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const o = (h) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Wt(h).point);
    }, r = (h, f) => {
      const { drag: d, dragPropagation: m, onDragStart: v } = this.getProps();
      if (d && !m && (this.openDragLock && this.openDragLock(), this.openDragLock = Fa(d), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), $((p) => {
        let T = this.getAxisMotionValue(p).get() || 0;
        if (X.test(T)) {
          const { projection: g } = this.visualElement;
          if (g && g.layout) {
            const b = g.layout.layoutBox[p];
            b && (T = B(b) * (parseFloat(T) / 100));
          }
        }
        this.originPoint[p] = T;
      }), v && S.postRender(() => v(h, f)), Ne(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, a = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f;
      const { dragPropagation: d, dragDirectionLock: m, onDirectionLock: v, onDrag: y } = this.getProps();
      if (!d && !this.openDragLock)
        return;
      const { offset: p } = f;
      if (m && this.currentDirection === null) {
        this.currentDirection = Dc(p), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, p), this.updateAxis("y", f.point, p), this.visualElement.render(), y && y(h, f);
    }, l = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f, this.stop(h, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => $((h) => this.getAnimationState(h) === "paused" && this.getAxisMotionValue(h).animation?.play()), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new Pr(e, {
      onSessionStart: o,
      onStart: r,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: s,
      contextWindow: xr(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(e, n) {
    const s = e || this.latestPointerEvent, i = n || this.latestPanInfo, o = this.isDragging;
    if (this.cancel(), !o || !i || !s)
      return;
    const { velocity: r } = i;
    this.startAnimation(r);
    const { onDragEnd: a } = this.getProps();
    a && S.postRender(() => a(s, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: s } = this.getProps();
    !s && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, s) {
    const { drag: i } = this.getProps();
    if (!s || !zt(e, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(e);
    let r = this.originPoint[e] + s[e];
    this.constraints && this.constraints[e] && (r = xc(r, this.constraints[e], this.elastic[e])), o.set(r);
  }
  resolveConstraints() {
    const { dragConstraints: e, dragElastic: n } = this.getProps(), s = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, i = this.constraints;
    e && dt(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && s ? this.constraints = Pc(s.layoutBox, e) : this.constraints = !1, this.elastic = Ac(n), i !== this.constraints && s && this.constraints && !this.hasMutatedConstraints && $((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = Sc(s.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !dt(e))
      return !1;
    const s = e.current;
    H(s !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const o = gc(s, i.root, this.visualElement.getTransformPagePoint());
    let r = wc(i.layout.layoutBox, o);
    if (n) {
      const a = n(ac(r));
      this.hasMutatedConstraints = !!a, a && (r = mr(a));
    }
    return r;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: s, dragElastic: i, dragTransition: o, dragSnapToOrigin: r, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, u = $((c) => {
      if (!zt(c, n, this.currentDirection))
        return;
      let h = l && l[c] || {};
      r && (h = { min: 0, max: 0 });
      const f = i ? 200 : 1e6, d = i ? 40 : 1e7, m = {
        type: "inertia",
        velocity: s ? e[c] : 0,
        bounceStiffness: f,
        bounceDamping: d,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...h
      };
      return this.startAxisValueAnimation(c, m);
    });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(e, n) {
    const s = this.getAxisMotionValue(e);
    return Ne(this.visualElement, e), s.start(Dn(e, s, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    $((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    $((e) => this.getAxisMotionValue(e).animation?.pause());
  }
  getAnimationState(e) {
    return this.getAxisMotionValue(e).animation?.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, s = this.visualElement.getProps(), i = s[n];
    return i || this.visualElement.getValue(e, (s.initial ? s.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    $((n) => {
      const { drag: s } = this.getProps();
      if (!zt(n, s, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: r, max: a } = i.layout.layoutBox[n];
        o.set(e[n] - M(r, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: s } = this.visualElement;
    if (!dt(n) || !s || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    $((r) => {
      const a = this.getAxisMotionValue(r);
      if (a && this.constraints !== !1) {
        const l = a.get();
        i[r] = bc({ min: l, max: l }, this.constraints[r]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", s.root && s.root.updateScroll(), s.updateLayout(), this.resolveConstraints(), $((r) => {
      if (!zt(r, e, null))
        return;
      const a = this.getAxisMotionValue(r), { min: l, max: u } = this.constraints[r];
      a.set(M(l, u, i[r]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Vc.set(this.visualElement, this);
    const e = this.visualElement.current, n = Dt(e, "pointerdown", (l) => {
      const { drag: u, dragListener: c = !0 } = this.getProps();
      u && c && this.start(l);
    }), s = () => {
      const { dragConstraints: l } = this.getProps();
      dt(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, o = i.addEventListener("measure", s);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), S.read(s);
    const r = Ot(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", (({ delta: l, hasLayoutChanged: u }) => {
      this.isDragging && u && ($((c) => {
        const h = this.getAxisMotionValue(c);
        h && (this.originPoint[c] += l[c].translate, h.set(h.get() + l[c].translate));
      }), this.visualElement.render());
    }));
    return () => {
      r(), n(), o(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: s = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: r = Ke, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: s,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: r,
      dragMomentum: a
    };
  }
}
function zt(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function Dc(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class Cc extends et {
  constructor(e) {
    super(e), this.removeGroupControls = N, this.removeListeners = N, this.controls = new Mc(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || N;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Ts = (t) => (e, n) => {
  t && S.postRender(() => t(e, n));
};
class Ec extends et {
  constructor() {
    super(...arguments), this.removePointerDownListener = N;
  }
  onPointerDown(e) {
    this.session = new Pr(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: xr(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: s, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: Ts(e),
      onStart: Ts(n),
      onMove: s,
      onEnd: (o, r) => {
        delete this.session, i && S.postRender(() => i(o, r));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Dt(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Jt = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function xs(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const St = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (x.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = xs(t, e.target.x), s = xs(t, e.target.y);
    return `${n}% ${s}%`;
  }
}, Rc = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const s = t, i = tt.parse(t);
    if (i.length > 5)
      return s;
    const o = tt.createTransformer(t), r = typeof i[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    i[0 + r] /= a, i[1 + r] /= l;
    const u = M(a, l, 0.5);
    return typeof i[2 + r] == "number" && (i[2 + r] /= u), typeof i[3 + r] == "number" && (i[3 + r] /= u), o(i);
  }
};
let Ps = !1;
class Lc extends Hr {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s, layoutId: i } = this.props, { projection: o } = e;
    gl(kc), o && (n.group && n.group.add(o), s && s.register && i && s.register(o), Ps && o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      onExitComplete: () => this.safeToRemove()
    })), Jt.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: s, drag: i, isPresent: o } = this.props, { projection: r } = s;
    return r && (r.isPresent = o, Ps = !0, i || e.layoutDependency !== n || n === void 0 || e.isPresent !== o ? r.willUpdate() : this.safeToRemove(), e.isPresent !== o && (o ? r.promote() : r.relegate() || S.postRender(() => {
      const a = r.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), yn.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s } = this.props, { projection: i } = e;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), s && s.deregister && s.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function br(t) {
  const [e, n] = Qa(), s = I(ti);
  return O.jsx(Lc, { ...t, layoutGroup: s, switchLayoutGroup: I(er), isPresent: e, safeToRemove: n });
}
const kc = {
  borderRadius: {
    ...St,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: St,
  borderTopRightRadius: St,
  borderBottomLeftRadius: St,
  borderBottomRightRadius: St,
  boxShadow: Rc
};
function Bc(t, e, n) {
  const s = L(t) ? t : G(t);
  return s.start(Dn("", s, e, n)), s.animation;
}
const Fc = (t, e) => t.depth - e.depth;
class Oc {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    qe(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Ze(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(Fc), this.isDirty = !1, this.children.forEach(e);
  }
}
function Ic(t, e) {
  const n = j.now(), s = ({ timestamp: i }) => {
    const o = i - n;
    o >= e && (q(s), t(o - e));
  };
  return S.setup(s, !0), () => q(s);
}
const Sr = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], jc = Sr.length, ws = (t) => typeof t == "string" ? parseFloat(t) : t, bs = (t) => typeof t == "number" || x.test(t);
function Nc(t, e, n, s, i, o) {
  i ? (t.opacity = M(0, n.opacity ?? 1, Wc(s)), t.opacityExit = M(e.opacity ?? 1, 0, Uc(s))) : o && (t.opacity = M(e.opacity ?? 1, n.opacity ?? 1, s));
  for (let r = 0; r < jc; r++) {
    const a = `border${Sr[r]}Radius`;
    let l = Ss(e, a), u = Ss(n, a);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || bs(l) === bs(u) ? (t[a] = Math.max(M(ws(l), ws(u), s), 0), (X.test(u) || X.test(l)) && (t[a] += "%")) : t[a] = u;
  }
  (e.rotate || n.rotate) && (t.rotate = M(e.rotate || 0, n.rotate || 0, s));
}
function Ss(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const Wc = /* @__PURE__ */ Ar(0, 0.5, fi), Uc = /* @__PURE__ */ Ar(0.5, 0.95, N);
function Ar(t, e, n) {
  return (s) => s < t ? 0 : s > e ? 1 : n(/* @__PURE__ */ yt(t, e, s));
}
function As(t, e) {
  t.min = e.min, t.max = e.max;
}
function U(t, e) {
  As(t.x, e.x), As(t.y, e.y);
}
function Vs(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function Ms(t, e, n, s, i) {
  return t -= e, t = se(t, 1 / n, s), i !== void 0 && (t = se(t, 1 / i, s)), t;
}
function $c(t, e = 0, n = 1, s = 0.5, i, o = t, r = t) {
  if (X.test(e) && (e = parseFloat(e), e = M(r.min, r.max, e / 100) - r.min), typeof e != "number")
    return;
  let a = M(o.min, o.max, s);
  t === o && (a -= e), t.min = Ms(t.min, e, n, a, i), t.max = Ms(t.max, e, n, a, i);
}
function Ds(t, e, [n, s, i], o, r) {
  $c(t, e[n], e[s], e[i], e.scale, o, r);
}
const Kc = ["x", "scaleX", "originX"], zc = ["y", "scaleY", "originY"];
function Cs(t, e, n, s) {
  Ds(t.x, e, Kc, n ? n.x : void 0, s ? s.x : void 0), Ds(t.y, e, zc, n ? n.y : void 0, s ? s.y : void 0);
}
function Es(t) {
  return t.translate === 0 && t.scale === 1;
}
function Vr(t) {
  return Es(t.x) && Es(t.y);
}
function Rs(t, e) {
  return t.min === e.min && t.max === e.max;
}
function Hc(t, e) {
  return Rs(t.x, e.x) && Rs(t.y, e.y);
}
function Ls(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function Mr(t, e) {
  return Ls(t.x, e.x) && Ls(t.y, e.y);
}
function ks(t) {
  return B(t.x) / B(t.y);
}
function Bs(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class Gc {
  constructor() {
    this.members = [];
  }
  add(e) {
    qe(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Ze(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let s;
    for (let i = n; i >= 0; i--) {
      const o = this.members[i];
      if (o.isPresent !== !1) {
        s = o;
        break;
      }
    }
    return s ? (this.promote(s), !0) : !1;
  }
  promote(e, n) {
    const s = this.lead;
    if (e !== s && (this.prevLead = s, this.lead = e, e.show(), s)) {
      s.instance && s.scheduleRender(), e.scheduleRender(), e.resumeFrom = s, n && (e.resumeFrom.preserveOpacity = !0), s.snapshot && (e.snapshot = s.snapshot, e.snapshot.latestValues = s.animationValues || s.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && s.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: s } = e;
      n.onExitComplete && n.onExitComplete(), s && s.options.onExitComplete && s.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function _c(t, e, n) {
  let s = "";
  const i = t.x.translate / e.x, o = t.y.translate / e.y, r = n?.z || 0;
  if ((i || o || r) && (s = `translate3d(${i}px, ${o}px, ${r}px) `), (e.x !== 1 || e.y !== 1) && (s += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: u, rotate: c, rotateX: h, rotateY: f, skewX: d, skewY: m } = n;
    u && (s = `perspective(${u}px) ${s}`), c && (s += `rotate(${c}deg) `), h && (s += `rotateX(${h}deg) `), f && (s += `rotateY(${f}deg) `), d && (s += `skewX(${d}deg) `), m && (s += `skewY(${m}deg) `);
  }
  const a = t.x.scale * e.x, l = t.y.scale * e.y;
  return (a !== 1 || l !== 1) && (s += `scale(${a}, ${l})`), s || "none";
}
const Pe = ["", "X", "Y", "Z"], Xc = 1e3;
let Yc = 0;
function we(t, e, n, s) {
  const { latestValues: i } = e;
  i[t] && (n[t] = i[t], e.setStaticValue(t, 0), s && (s[t] = 0));
}
function Dr(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = ur(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", S, !(i || o));
  }
  const { parent: s } = t;
  s && !s.hasCheckedOptimisedAppear && Dr(s);
}
function Cr({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: s, resetTransform: i }) {
  return class {
    constructor(r = {}, a = e?.()) {
      this.id = Yc++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Jc), this.nodes.forEach(nu), this.nodes.forEach(su), this.nodes.forEach(Qc);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = r, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Oc());
    }
    addEventListener(r, a) {
      return this.eventHandlers.has(r) || this.eventHandlers.set(r, new Qe()), this.eventHandlers.get(r).add(a);
    }
    notifyListeners(r, ...a) {
      const l = this.eventHandlers.get(r);
      l && l.notify(...a);
    }
    hasListeners(r) {
      return this.eventHandlers.has(r);
    }
    /**
     * Lifecycles
     */
    mount(r) {
      if (this.instance)
        return;
      this.isSVG = Tn(r) && !qa(r), this.instance = r;
      const { layoutId: a, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(r), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), t) {
        let c, h = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        S.read(() => {
          h = window.innerWidth;
        }), t(r, () => {
          const d = window.innerWidth;
          d !== h && (h = d, this.root.updateBlockedByResize = !0, c && c(), c = Ic(f, 250), Jt.hasAnimatedSinceResize && (Jt.hasAnimatedSinceResize = !1, this.nodes.forEach(Is)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: h, hasRelativeLayoutChanged: f, layout: d }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const m = this.options.transition || u.getDefaultTransition() || lu, { onLayoutAnimationStart: v, onLayoutAnimationComplete: y } = u.getProps(), p = !this.targetLayout || !Mr(this.targetLayout, d), T = !h && f;
        if (this.options.layoutRoot || this.resumeFrom || T || h && (p || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const g = {
            ...pn(m, "layout"),
            onPlay: v,
            onComplete: y
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (g.delay = 0, g.type = !1), this.startAnimation(g), this.setAnimationOrigin(c, T);
        } else
          h || Is(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = d;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const r = this.getStack();
      r && r.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), q(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(iu), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: r } = this.options;
      return r && r.getProps().transformTemplate;
    }
    willUpdate(r = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Dr(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const h = this.path[c];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), r && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Fs);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Os);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(eu), this.nodes.forEach(qc), this.nodes.forEach(Zc)) : this.nodes.forEach(Os), this.clearAllSnapshots();
      const a = j.now();
      R.delta = Y(0, 1e3 / 60, a - R.timestamp), R.timestamp = a, R.isProcessing = !0, fe.update.process(R), fe.preRender.process(R), fe.render.process(R), R.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, yn.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(tu), this.sharedNodes.forEach(ru);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, S.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      S.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !B(this.snapshot.measuredBox.x) && !B(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const r = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = D(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, r ? r.layoutBox : void 0);
    }
    updateScroll(r = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === r && (a = !1), a && this.instance) {
        const l = s(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: r,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const r = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Vr(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      r && this.instance && (a || st(this.latestValues) || c) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(r = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return r && (l = this.removeTransform(l)), cu(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: r } = this.options;
      if (!r)
        return D();
      const a = r.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(uu))) {
        const { scroll: u } = this.root;
        u && (pt(a.x, u.offset.x), pt(a.y, u.offset.y));
      }
      return a;
    }
    removeElementScroll(r) {
      const a = D();
      if (U(a, r), this.scroll?.wasRoot)
        return a;
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l], { scroll: c, options: h } = u;
        u !== this.root && c && h.layoutScroll && (c.wasRoot && U(a, r), pt(a.x, c.offset.x), pt(a.y, c.offset.y));
      }
      return a;
    }
    applyTransform(r, a = !1) {
      const l = D();
      U(l, r);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        !a && c.options.layoutScroll && c.scroll && c !== c.root && gt(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), st(c.latestValues) && gt(l, c.latestValues);
      }
      return st(this.latestValues) && gt(l, this.latestValues), l;
    }
    removeTransform(r) {
      const a = D();
      U(a, r);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!u.instance || !st(u.latestValues))
          continue;
        Ue(u.latestValues) && u.updateSnapshot();
        const c = D(), h = u.measurePageBox();
        U(c, h), Cs(a, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, c);
      }
      return st(this.latestValues) && Cs(a, this.latestValues), a;
    }
    setTargetDelta(r) {
      this.targetDelta = r, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(r) {
      this.options = {
        ...this.options,
        ...r,
        crossfade: r.crossfade !== void 0 ? r.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== R.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(r = !1) {
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(r || l && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: h } = this.options;
      if (!(!this.layout || !(c || h))) {
        if (this.resolvedRelativeTargetAt = R.timestamp, !this.targetDelta && !this.relativeTarget) {
          const f = this.getClosestProjectingParent();
          f && f.layout && this.animationProgress !== 1 ? (this.relativeParent = f, this.forceRelativeParentToResolveTarget(), this.relativeTarget = D(), this.relativeTargetOrigin = D(), Et(this.relativeTargetOrigin, this.layout.layoutBox, f.layout.layoutBox), U(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = D(), this.targetWithTransforms = D()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), mc(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : U(this.target, this.layout.layoutBox), vr(this.target, this.targetDelta)) : U(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const f = this.getClosestProjectingParent();
          f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? (this.relativeParent = f, this.forceRelativeParentToResolveTarget(), this.relativeTarget = D(), this.relativeTargetOrigin = D(), Et(this.relativeTargetOrigin, this.target, f.target), U(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Ue(this.parent.latestValues) || yr(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      const r = this.getLead(), a = !!this.resumingFrom || this !== r;
      let l = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === R.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      U(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, f = this.treeScale.y;
      pc(this.layoutCorrected, this.treeScale, this.path, a), r.layout && !r.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (r.target = r.layout.layoutBox, r.targetWithTransforms = D());
      const { target: d } = r;
      if (!d) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Vs(this.prevProjectionDelta.x, this.projectionDelta.x), Vs(this.prevProjectionDelta.y, this.projectionDelta.y)), Ct(this.projectionDelta, this.layoutCorrected, d, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== f || !Bs(this.projectionDelta.x, this.prevProjectionDelta.x) || !Bs(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(r = !0) {
      if (this.options.visualElement?.scheduleRender(), r) {
        const a = this.getStack();
        a && a.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = mt(), this.projectionDelta = mt(), this.projectionDeltaWithTransform = mt();
    }
    setAnimationOrigin(r, a = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, h = mt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = D(), d = l ? l.source : void 0, m = this.layout ? this.layout.source : void 0, v = d !== m, y = this.getStack(), p = !y || y.members.length <= 1, T = !!(v && !p && this.options.crossfade === !0 && !this.path.some(au));
      this.animationProgress = 0;
      let g;
      this.mixTargetDelta = (b) => {
        const P = b / 1e3;
        js(h.x, r.x, P), js(h.y, r.y, P), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Et(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), ou(this.relativeTarget, this.relativeTargetOrigin, f, P), g && Hc(this.relativeTarget, g) && (this.isProjectionDirty = !1), g || (g = D()), U(g, this.relativeTarget)), v && (this.animationValues = c, Nc(c, u, this.latestValues, P, T, p)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = P;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(r) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (q(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = S.update(() => {
        Jt.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = G(0)), this.currentAnimation = Bc(this.motionValue, [0, 1e3], {
          ...r,
          velocity: 0,
          isSync: !0,
          onUpdate: (a) => {
            this.mixTargetDelta(a), r.onUpdate && r.onUpdate(a);
          },
          onStop: () => {
          },
          onComplete: () => {
            r.onComplete && r.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const r = this.getStack();
      r && r.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Xc), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const r = this.getLead();
      let { targetWithTransforms: a, target: l, layout: u, latestValues: c } = r;
      if (!(!a || !l || !u)) {
        if (this !== r && this.layout && u && Er(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || D();
          const h = B(this.layout.layoutBox.x);
          l.x.min = r.target.x.min, l.x.max = l.x.min + h;
          const f = B(this.layout.layoutBox.y);
          l.y.min = r.target.y.min, l.y.max = l.y.min + f;
        }
        U(a, l), gt(a, c), Ct(this.projectionDeltaWithTransform, this.layoutCorrected, a, c);
      }
    }
    registerSharedNode(r, a) {
      this.sharedNodes.has(r) || this.sharedNodes.set(r, new Gc()), this.sharedNodes.get(r).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const r = this.getStack();
      return r ? r.lead === this : !0;
    }
    getLead() {
      const { layoutId: r } = this.options;
      return r ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: r } = this.options;
      return r ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: r } = this.options;
      if (r)
        return this.root.sharedNodes.get(r);
    }
    promote({ needsReset: r, transition: a, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), r && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const r = this.getStack();
      return r ? r.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: r } = this.options;
      if (!r)
        return;
      let a = !1;
      const { latestValues: l } = r;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const u = {};
      l.z && we("z", r, u, this.animationValues);
      for (let c = 0; c < Pe.length; c++)
        we(`rotate${Pe[c]}`, r, u, this.animationValues), we(`skew${Pe[c]}`, r, u, this.animationValues);
      r.render();
      for (const c in u)
        r.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      r.scheduleRender();
    }
    applyProjectionStyles(r, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        r.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, r.visibility = "", r.opacity = "", r.pointerEvents = Zt(a?.pointerEvents) || "", r.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (r.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, r.pointerEvents = Zt(a?.pointerEvents) || ""), this.hasProjected && !st(this.latestValues) && (r.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      r.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let h = _c(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (h = l(c, h)), r.transform = h;
      const { x: f, y: d } = this.projectionDelta;
      r.transformOrigin = `${f.origin * 100}% ${d.origin * 100}% 0`, u.animationValues ? r.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : r.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const m in Bt) {
        if (c[m] === void 0)
          continue;
        const { correct: v, applyTo: y, isCSSVariable: p } = Bt[m], T = h === "none" ? c[m] : v(c[m], u);
        if (y) {
          const g = y.length;
          for (let b = 0; b < g; b++)
            r[y[b]] = T;
        } else
          p ? this.options.visualElement.renderState.vars[m] = T : r[m] = T;
      }
      this.options.layoutId && (r.pointerEvents = u === this ? Zt(a?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((r) => r.currentAnimation?.stop()), this.root.nodes.forEach(Fs), this.root.sharedNodes.clear();
    }
  };
}
function qc(t) {
  t.updateLayout();
}
function Zc(t) {
  const e = t.resumeFrom?.snapshot || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: s } = t.layout, { animationType: i } = t.options, o = e.source !== t.layout.source;
    i === "size" ? $((c) => {
      const h = o ? e.measuredBox[c] : e.layoutBox[c], f = B(h);
      h.min = n[c].min, h.max = h.min + f;
    }) : Er(i, e.layoutBox, n) && $((c) => {
      const h = o ? e.measuredBox[c] : e.layoutBox[c], f = B(n[c]);
      h.max = h.min + f, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[c].max = t.relativeTarget[c].min + f);
    });
    const r = mt();
    Ct(r, n, e.layoutBox);
    const a = mt();
    o ? Ct(a, t.applyTransform(s, !0), e.measuredBox) : Ct(a, n, e.layoutBox);
    const l = !Vr(r);
    let u = !1;
    if (!t.resumeFrom) {
      const c = t.getClosestProjectingParent();
      if (c && !c.resumeFrom) {
        const { snapshot: h, layout: f } = c;
        if (h && f) {
          const d = D();
          Et(d, e.layoutBox, h.layoutBox);
          const m = D();
          Et(m, n, f.layoutBox), Mr(d, m) || (u = !0), c.options.layoutRoot && (t.relativeTarget = m, t.relativeTargetOrigin = d, t.relativeParent = c);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: n,
      snapshot: e,
      delta: a,
      layoutDelta: r,
      hasLayoutChanged: l,
      hasRelativeLayoutChanged: u
    });
  } else if (t.isLead()) {
    const { onExitComplete: n } = t.options;
    n && n();
  }
  t.options.transition = void 0;
}
function Jc(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function Qc(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function tu(t) {
  t.clearSnapshot();
}
function Fs(t) {
  t.clearMeasurements();
}
function Os(t) {
  t.isLayoutDirty = !1;
}
function eu(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Is(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function nu(t) {
  t.resolveTargetDelta();
}
function su(t) {
  t.calcProjection();
}
function iu(t) {
  t.resetSkewAndRotation();
}
function ru(t) {
  t.removeLeadSnapshot();
}
function js(t, e, n) {
  t.translate = M(e.translate, 0, n), t.scale = M(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Ns(t, e, n, s) {
  t.min = M(e.min, n.min, s), t.max = M(e.max, n.max, s);
}
function ou(t, e, n, s) {
  Ns(t.x, e.x, n.x, s), Ns(t.y, e.y, n.y, s);
}
function au(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const lu = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Ws = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), Us = Ws("applewebkit/") && !Ws("chrome/") ? Math.round : N;
function $s(t) {
  t.min = Us(t.min), t.max = Us(t.max);
}
function cu(t) {
  $s(t.x), $s(t.y);
}
function Er(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !dc(ks(e), ks(n), 0.2);
}
function uu(t) {
  return t !== t.root && t.scroll?.wasRoot;
}
const hu = Cr({
  attachResizeListener: (t, e) => Ot(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), be = {
  current: void 0
}, Rr = Cr({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!be.current) {
      const t = new hu({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), be.current = t;
    }
    return be.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), fu = {
  pan: {
    Feature: Ec
  },
  drag: {
    Feature: Cc,
    ProjectionNode: Rr,
    MeasureLayout: br
  }
};
function Ks(t, e, n) {
  const { props: s } = t;
  t.animationState && s.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = s[i];
  o && S.postRender(() => o(e, Wt(e)));
}
class du extends et {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = Oa(e, (n, s) => (Ks(this.node, s, "Start"), (i) => Ks(this.node, i, "End"))));
  }
  unmount() {
  }
}
class mu extends et {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = It(Ot(this.node.current, "focus", () => this.onFocus()), Ot(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function zs(t, e, n) {
  const { props: s } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && s.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = s[i];
  o && S.postRender(() => o(e, Wt(e)));
}
class pu extends et {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = Wa(e, (n, s) => (zs(this.node, s, "Start"), (i, { success: o }) => zs(this.node, i, o ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const ze = /* @__PURE__ */ new WeakMap(), Se = /* @__PURE__ */ new WeakMap(), gu = (t) => {
  const e = ze.get(t.target);
  e && e(t);
}, yu = (t) => {
  t.forEach(gu);
};
function vu({ root: t, ...e }) {
  const n = t || document;
  Se.has(n) || Se.set(n, {});
  const s = Se.get(n), i = JSON.stringify(e);
  return s[i] || (s[i] = new IntersectionObserver(yu, { root: t, ...e })), s[i];
}
function Tu(t, e, n) {
  const s = vu(e);
  return ze.set(t, n), s.observe(t), () => {
    ze.delete(t), s.unobserve(t);
  };
}
const xu = {
  some: 0,
  all: 1
};
class Pu extends et {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: s, amount: i = "some", once: o } = e, r = {
      root: n ? n.current : void 0,
      rootMargin: s,
      threshold: typeof i == "number" ? i : xu[i]
    }, a = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, o && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: h } = this.node.getProps(), f = u ? c : h;
      f && f(l);
    };
    return Tu(this.node.current, r, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(wu(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function wu({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const bu = {
  inView: {
    Feature: Pu
  },
  tap: {
    Feature: pu
  },
  focus: {
    Feature: mu
  },
  hover: {
    Feature: du
  }
}, Su = {
  layout: {
    ProjectionNode: Rr,
    MeasureLayout: br
  }
}, He = { current: null }, Lr = { current: !1 };
function Au() {
  if (Lr.current = !0, !!Xe)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => He.current = t.matches;
      t.addEventListener("change", e), e();
    } else
      He.current = !1;
}
const Vu = /* @__PURE__ */ new WeakMap();
function Mu(t, e, n) {
  for (const s in e) {
    const i = e[s], o = n[s];
    if (L(i))
      t.addValue(s, i);
    else if (L(o))
      t.addValue(s, G(i, { owner: t }));
    else if (o !== i)
      if (t.hasValue(s)) {
        const r = t.getValue(s);
        r.liveStyle === !0 ? r.jump(i) : r.hasAnimated || r.set(i);
      } else {
        const r = t.getStaticValue(s);
        t.addValue(s, G(r !== void 0 ? r : i, { owner: t }));
      }
  }
  for (const s in n)
    e[s] === void 0 && t.removeValue(s);
  return e;
}
const Hs = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class Du {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, s) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: s, reducedMotionConfig: i, blockInitialAnimation: o, visualState: r }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = dn, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = j.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, S.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = r;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = e, this.props = n, this.presenceContext = s, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!o, this.isControllingVariants = ce(n), this.isVariantNode = Qi(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: c, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in h) {
      const d = h[f];
      l[f] !== void 0 && L(d) && d.set(l[f], !1);
    }
  }
  mount(e) {
    this.current = e, Vu.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, s) => this.bindToMotionValue(s, n)), Lr.current || Au(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : He.current, process.env.NODE_ENV !== "production" && oe(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), q(this.notifyUpdate), q(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const s = bt.has(e);
    s && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (a) => {
      this.latestValues[e] = a, this.props.onUpdate && S.preRender(this.notifyUpdate), s && this.projection && (this.projection.isTransformDirty = !0);
    }), o = n.on("renderRequest", this.scheduleRender);
    let r;
    window.MotionCheckAppearSync && (r = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      i(), o(), r && r(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in vt) {
      const n = vt[e];
      if (!n)
        continue;
      const { isEnabled: s, Feature: i } = n;
      if (!this.features[e] && i && s(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const o = this.features[e];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : D();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let s = 0; s < Hs.length; s++) {
      const i = Hs[s];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, r = e[o];
      r && (this.propEventSubscriptions[i] = this.on(i, r));
    }
    this.prevMotionValues = Mu(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const s = this.values.get(e);
    n !== s && (s && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let s = this.values.get(e);
    return s === void 0 && n !== void 0 && (s = G(n === null ? void 0 : n, { owner: this }), this.addValue(e, s)), s;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    let s = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return s != null && (typeof s == "string" && (si(s) || ri(s)) ? s = parseFloat(s) : !Ja(s) && tt.test(n) && (s = $i(e, n)), this.setBaseTarget(e, L(s) ? s.get() : s)), L(s) ? s.get() : s;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    const { initial: n } = this.props;
    let s;
    if (typeof n == "string" || typeof n == "object") {
      const o = Vn(this.props, n, this.presenceContext?.custom);
      o && (s = o[e]);
    }
    if (n && s !== void 0)
      return s;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !L(i) ? i : this.initialValues[e] !== void 0 && s === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Qe()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class kr extends Du {
  constructor() {
    super(...arguments), this.KeyframeResolver = La;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: s }) {
    delete n[e], delete s[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    L(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Br(t, { style: e, vars: n }, s, i) {
  const o = t.style;
  let r;
  for (r in e)
    o[r] = e[r];
  i?.applyProjectionStyles(o, s);
  for (r in n)
    o.setProperty(r, n[r]);
}
function Cu(t) {
  return window.getComputedStyle(t);
}
class Eu extends kr {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Br;
  }
  readValueFromInstance(e, n) {
    if (bt.has(n))
      return this.projection?.isProjecting ? Le(n) : Zo(e, n);
    {
      const s = Cu(e), i = (sn(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Tr(e, n);
  }
  build(e, n, s) {
    bn(e, n, s.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return Mn(e, n, s);
  }
}
const Fr = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Ru(t, e, n, s) {
  Br(t, e, void 0, s);
  for (const i in e.attrs)
    t.setAttribute(Fr.has(i) ? i : wn(i), e.attrs[i]);
}
class Lu extends kr {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = D;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (bt.has(n)) {
      const s = Ui(n);
      return s && s.default || 0;
    }
    return n = Fr.has(n) ? n : wn(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return cr(e, n, s);
  }
  build(e, n, s) {
    rr(e, n, this.isSVGTag, s.transformTemplate, s.style);
  }
  renderInstance(e, n, s, i) {
    Ru(e, n, s, i);
  }
  mount(e) {
    this.isSVGTag = ar(e.tagName), super.mount(e);
  }
}
const ku = (t, e) => An(t) ? new Lu(e) : new Eu(e, {
  allowProjection: t !== Qs
}), Bu = /* @__PURE__ */ kl({
  ...rc,
  ...bu,
  ...fu,
  ...Su
}, ku), Fu = /* @__PURE__ */ il(Bu), Ou = 50, Gs = () => ({
  current: 0,
  offset: [],
  progress: 0,
  scrollLength: 0,
  targetOffset: 0,
  targetLength: 0,
  containerLength: 0,
  velocity: 0
}), Iu = () => ({
  time: 0,
  x: Gs(),
  y: Gs()
}), ju = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};
function _s(t, e, n, s) {
  const i = n[e], { length: o, position: r } = ju[e], a = i.current, l = n.time;
  i.current = t[`scroll${r}`], i.scrollLength = t[`scroll${o}`] - t[`client${o}`], i.offset.length = 0, i.offset[0] = 0, i.offset[1] = i.scrollLength, i.progress = /* @__PURE__ */ yt(0, i.scrollLength, i.current);
  const u = s - l;
  i.velocity = u > Ou ? 0 : tn(i.current - a, u);
}
function Nu(t, e, n) {
  _s(t, "x", e, n), _s(t, "y", e, n), e.time = n;
}
function Wu(t, e) {
  const n = { x: 0, y: 0 };
  let s = t;
  for (; s && s !== e; )
    if (mn(s))
      n.x += s.offsetLeft, n.y += s.offsetTop, s = s.offsetParent;
    else if (s.tagName === "svg") {
      const i = s.getBoundingClientRect();
      s = s.parentElement;
      const o = s.getBoundingClientRect();
      n.x += i.left - o.left, n.y += i.top - o.top;
    } else if (s instanceof SVGGraphicsElement) {
      const { x: i, y: o } = s.getBBox();
      n.x += i, n.y += o;
      let r = null, a = s.parentNode;
      for (; !r; )
        a.tagName === "svg" && (r = a), a = s.parentNode;
      s = r;
    } else
      break;
  return n;
}
const Ge = {
  start: 0,
  center: 0.5,
  end: 1
};
function Xs(t, e, n = 0) {
  let s = 0;
  if (t in Ge && (t = Ge[t]), typeof t == "string") {
    const i = parseFloat(t);
    t.endsWith("px") ? s = i : t.endsWith("%") ? t = i / 100 : t.endsWith("vw") ? s = i / 100 * document.documentElement.clientWidth : t.endsWith("vh") ? s = i / 100 * document.documentElement.clientHeight : t = i;
  }
  return typeof t == "number" && (s = e * t), n + s;
}
const Uu = [0, 0];
function $u(t, e, n, s) {
  let i = Array.isArray(t) ? t : Uu, o = 0, r = 0;
  return typeof t == "number" ? i = [t, t] : typeof t == "string" && (t = t.trim(), t.includes(" ") ? i = t.split(" ") : i = [t, Ge[t] ? t : "0"]), o = Xs(i[0], n, s), r = Xs(i[1], e), o - r;
}
const Ku = {
  All: [
    [0, 0],
    [1, 1]
  ]
}, zu = { x: 0, y: 0 };
function Hu(t) {
  return "getBBox" in t && t.tagName !== "svg" ? t.getBBox() : { width: t.clientWidth, height: t.clientHeight };
}
function Gu(t, e, n) {
  const { offset: s = Ku.All } = n, { target: i = t, axis: o = "y" } = n, r = o === "y" ? "height" : "width", a = i !== t ? Wu(i, t) : zu, l = i === t ? { width: t.scrollWidth, height: t.scrollHeight } : Hu(i), u = {
    width: t.clientWidth,
    height: t.clientHeight
  };
  e[o].offset.length = 0;
  let c = !e[o].interpolate;
  const h = s.length;
  for (let f = 0; f < h; f++) {
    const d = $u(s[f], u[r], l[r], a[o]);
    !c && d !== e[o].interpolatorOffsets[f] && (c = !0), e[o].offset[f] = d;
  }
  c && (e[o].interpolate = Mi(e[o].offset, Di(s), { clamp: !1 }), e[o].interpolatorOffsets = [...e[o].offset]), e[o].progress = Y(0, 1, e[o].interpolate(e[o].current));
}
function _u(t, e = t, n) {
  if (n.x.targetOffset = 0, n.y.targetOffset = 0, e !== t) {
    let s = e;
    for (; s && s !== t; )
      n.x.targetOffset += s.offsetLeft, n.y.targetOffset += s.offsetTop, s = s.offsetParent;
  }
  n.x.targetLength = e === t ? e.scrollWidth : e.clientWidth, n.y.targetLength = e === t ? e.scrollHeight : e.clientHeight, n.x.containerLength = t.clientWidth, n.y.containerLength = t.clientHeight, process.env.NODE_ENV !== "production" && t && e && e !== t && oe(getComputedStyle(t).position !== "static", "Please ensure that the container has a non-static position, like 'relative', 'fixed', or 'absolute' to ensure scroll offset is calculated correctly.");
}
function Xu(t, e, n, s = {}) {
  return {
    measure: (i) => {
      _u(t, s.target, n), Nu(t, n, i), (s.offset || s.target) && Gu(t, n, s);
    },
    notify: () => e(n)
  };
}
const At = /* @__PURE__ */ new WeakMap(), Ys = /* @__PURE__ */ new WeakMap(), Ae = /* @__PURE__ */ new WeakMap(), qs = (t) => t === document.scrollingElement ? window : t;
function Or(t, { container: e = document.scrollingElement, ...n } = {}) {
  if (!e)
    return N;
  let s = Ae.get(e);
  s || (s = /* @__PURE__ */ new Set(), Ae.set(e, s));
  const i = Iu(), o = Xu(e, t, i, n);
  if (s.add(o), !At.has(e)) {
    const a = () => {
      for (const h of s)
        h.measure(R.timestamp);
      S.preUpdate(l);
    }, l = () => {
      for (const h of s)
        h.notify();
    }, u = () => S.read(a);
    At.set(e, u);
    const c = qs(e);
    window.addEventListener("resize", u, { passive: !0 }), e !== document.documentElement && Ys.set(e, Ya(e, u)), c.addEventListener("scroll", u, { passive: !0 }), u();
  }
  const r = At.get(e);
  return S.read(r, !1, !0), () => {
    q(r);
    const a = Ae.get(e);
    if (!a || (a.delete(o), a.size))
      return;
    const l = At.get(e);
    At.delete(e), l && (qs(e).removeEventListener("scroll", l), Ys.get(e)?.(), window.removeEventListener("resize", l));
  };
}
const Zs = /* @__PURE__ */ new Map();
function Yu(t) {
  const e = { value: 0 }, n = Or((s) => {
    e.value = s[t.axis].progress * 100;
  }, t);
  return { currentTime: e, cancel: n };
}
function Ir({ source: t, container: e, ...n }) {
  const { axis: s } = n;
  t && (e = t);
  const i = Zs.get(e) ?? /* @__PURE__ */ new Map();
  Zs.set(e, i);
  const o = n.target ?? "self", r = i.get(o) ?? {}, a = s + (n.offset ?? []).join(",");
  return r[a] || (r[a] = !n.target && Li() ? new ScrollTimeline({ source: e, axis: s }) : Yu({ container: e, ...n })), r[a];
}
function qu(t, e) {
  const n = Ir(e);
  return t.attachTimeline({
    timeline: e.target ? void 0 : n,
    observe: (s) => (s.pause(), Yi((i) => {
      s.time = s.duration * i;
    }, n))
  });
}
function Zu(t) {
  return t.length === 2;
}
function Ju(t, e) {
  return Zu(t) ? Or((n) => {
    t(n[e.axis].progress, n);
  }, e) : Yi(t, Ir(e));
}
function Qu(t, { axis: e = "y", container: n = document.scrollingElement, ...s } = {}) {
  if (!n)
    return N;
  const i = { axis: e, container: n, ...s };
  return typeof t == "function" ? Ju(t, i) : qu(t, i);
}
const th = () => ({
  scrollX: G(0),
  scrollY: G(0),
  scrollXProgress: G(0),
  scrollYProgress: G(0)
}), Ht = (t) => t ? !t.current : !1;
function eh({ container: t, target: e, ...n } = {}) {
  const s = ei(th), i = ot(null), o = ot(!1), r = _e(() => (i.current = Qu((a, { x: l, y: u }) => {
    s.scrollX.set(l.current), s.scrollXProgress.set(l.progress), s.scrollY.set(u.current), s.scrollYProgress.set(u.progress);
  }, {
    ...n,
    container: t?.current || void 0,
    target: e?.current || void 0
  }), () => {
    i.current?.();
  }), [t, e, JSON.stringify(n.offset)]);
  return ni(() => {
    if (o.current = !1, Ht(t) || Ht(e)) {
      o.current = !0;
      return;
    } else
      return r();
  }, [r]), ie(() => {
    if (o.current)
      return H(!Ht(t), "Container ref is defined but not hydrated", "use-scroll-ref"), H(!Ht(e), "Target ref is defined but not hydrated", "use-scroll-ref"), r();
  }, [r]), s;
}
const nh = Yr("absolute left-0 right-0 h-3", {
  variants: {
    color: {
      primary: "bg-primary",
      onBackground: "bg-branded-foreground"
    },
    position: {
      bottom: "bottom-0",
      top: "top-0"
    }
  },
  defaultVariants: {
    color: "primary",
    position: "bottom"
  }
}), sh = ({
  containerRef: t,
  color: e,
  position: n
}) => {
  const { scrollXProgress: s } = eh({
    container: t,
    axis: "x"
  });
  return /* @__PURE__ */ O.jsx(
    Fu.div,
    {
      role: "progressbar",
      className: Js(nh({ color: e, position: n })),
      style: {
        scaleX: s,
        originX: 0
      }
    }
  );
}, jr = ({
  children: t,
  spacing: e,
  gap: n,
  animateScroll: s = !1,
  animateScrollStyles: i,
  fullBleed: o = !1,
  ...r
}) => {
  const a = ot(null), l = i?.position === "top" ? "pt-5" : "";
  return /* @__PURE__ */ O.jsx(Ut, { className: `${o ? "mx-[-24px] sm:mx-[-36px]" : ""}`, children: /* @__PURE__ */ O.jsxs(Ut, { className: "relative w-full h-fit", children: [
    /* @__PURE__ */ O.jsx(
      "div",
      {
        ref: a,
        className: Js(
          _r(n),
          Gr(e),
          `relative flex w-full snap-x snap-mandatory overflow-x-auto ${o ? "px-7 sm:px-10" : "px-4"} pb-6 ${l}`
        ),
        style: s ? {
          scrollbarWidth: "none"
        } : {},
        ...r,
        children: Rn.map(t, (u, c) => /* @__PURE__ */ O.jsx(Ut, { className: "snap-center snap-always shrink-0", children: u }, c))
      }
    ),
    s && Rn.count(t) > 1 && /* @__PURE__ */ O.jsx(Ut, { className: `relative ${o ? "mx-[24px] sm:mx-[36px]" : ""}`, children: /* @__PURE__ */ O.jsx(sh, { containerRef: a, ...i }) })
  ] }) });
};
jr.displayName = "Scroll";
const ih = ({
  children: t,
  scrollProps: e,
  gridProps: n
}) => {
  const { isLG: s } = qr(), { className: i, ...o } = n || {};
  return /* @__PURE__ */ O.jsxs(O.Fragment, { children: [
    !s && /* @__PURE__ */ O.jsx(jr, { gap: "5", ...e, children: t }),
    s && /* @__PURE__ */ O.jsx(
      Xr,
      {
        className: `grid-flow-col overflow-x-auto lg:grid-cols-3 lg:grid-flow-row gap-5 lg:gap-7 ${i || ""}`,
        ...o,
        children: t
      }
    )
  ] });
};
ih.displayName = "ScrollToGrid";
export {
  sh as A,
  jr as S,
  ih as a
};
